import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  MenuItem,
  DialogActions,
  IconButton,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Grid,
  alpha,
  Popover,
  useTheme,
  Alert,
  InputAdornment,
  Tooltip,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import AddLead from "./AddLead";
import { url } from "../constants/url";
import LeadRemarks from "./LeadRemarks";
import AssignTeamMemberLead from "./AssignTeamMemberLead";
import { useNavigate } from "react-router-dom";
import {
  RemoveRedEyeRounded,
  ArrowBack,
  ArrowForward,
  FilterList,
  Clear,
  Today,
  Event,
  CalendarToday,
  ViewList,
  Add,
  Phone,
  PhoneDisabled,
  PhoneCallback,
  PhoneForwarded,
  Edit,
  Assignment,
  Visibility,
  Delete,
  Preview,
  Send,
  Payment,
  Search,
  Groups as GroupsIcon, // 🆕 ADD THIS
  Chat as ChatIcon,
  Person,
  FileUpload,
  UploadFile,
} from "@mui/icons-material";
import { QuotationTemplates } from "./QuotationTemplates";
import { useThemeToggle } from "../context/ThemeContext";
import CustomAlert from "../components/customAlert";
import { ServicesMapping, ServiceOptions } from "../constants/serviceMapping";
import TeamCollaborationModal from "../components/TeamCollaborationModal";
import CollaborationTooltip from "../components/collabrationTooltip";
import { useRef } from "react";

const classificationStatuses = ["hot", "warm", "cold", "new", "follow-up", "dead", "closed"];
const quotationStatuses = ["quotation_shared", "quotation_approved", "quotation_rejected", "negotiation", "quotation_revised", "quotation_expired", "send_quotation"];

const Leads = ({ userData }) => {
  const theme = useTheme();
  const { mode } = useThemeToggle();
  const navigate = useNavigate();

  const [teamCollaborationOpen, setTeamCollaborationOpen] = useState(false);
  const [selectedLeadForCollaboration, setSelectedLeadForCollaboration] =
    useState(null);

  const [statusFilter, setStatusFilter] = useState("all");
  // Filter states
  const [dateFilter, setDateFilter] = useState("today");

  const [companyFilter, setCompanyFilter] = useState("all");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [tempFilters, setTempFilters] = useState({
    status: "all",
    company: "all",
  });

  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [paymentForm, setPaymentForm] = useState({
    amount: "",
    paymentType: "advance",
    paymentMethod: "bank_transfer",
    transactionId: "",
    remarks: "",
  });
  const [collaborationParticipants, setCollaborationParticipants] = useState(
    {}
  );

  const UID = userData?._id;
  const CID = userData?.companyAdded[0]?.companyId;
  const userRole = userData?.role;
  // Add these state variables
  const [revisionDialogOpen, setRevisionDialogOpen] = useState(false);
  const [selectedQuotationForRevision, setSelectedQuotationForRevision] =
    useState(null);
  const [leadsWithCollaboration, setLeadsWithCollaboration] = useState(
    new Set()
  );
  const [searchQuery, setSearchQuery] = useState("");


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchLeads();
      if (userRole === "superAdmin") {
        fetchCompanies();
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, companyFilter, UID, userRole, CID]);

  useEffect(() => {
    // Read URL parameters when component mounts
    const urlParams = new URLSearchParams(window.location.search);
    const statusFromUrl = urlParams.get('status');
    const dateFilterFromUrl = urlParams.get('dateFilter');

    console.log('URL Params received on mount:', { statusFromUrl, dateFilterFromUrl });

    // Apply status filter from URL
    if (statusFromUrl) {
      console.log('Setting status filter to:', statusFromUrl);
      setStatusFilter(statusFromUrl);
    }

    // Apply date filter from URL
    if (dateFilterFromUrl) {
      console.log('Setting date filter to:', dateFilterFromUrl);
      setDateFilter(dateFilterFromUrl);
    }
  }, []);

  // Add this useEffect to update URL when filters change
  useEffect(() => {
    const handleLocationChange = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const statusFromUrl = urlParams.get('status');
      const dateFilterFromUrl = urlParams.get('dateFilter');

      console.log('URL changed to:', { statusFromUrl, dateFilterFromUrl });

      if (statusFromUrl) {
        setStatusFilter(statusFromUrl);
      } else {
        setStatusFilter('all');
      }

      if (dateFilterFromUrl) {
        setDateFilter(dateFilterFromUrl);
      } else {
        setDateFilter('all');
      }
    };

    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', handleLocationChange);

    // Also check URL on component mount
    handleLocationChange();

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);
  const handleOpenTeamCollaboration = (lead) => {
    setSelectedLeadForCollaboration(lead);
    setTeamCollaborationOpen(true);
  };

  const handleCloseTeamCollaboration = () => {
    setTeamCollaborationOpen(false);
    setSelectedLeadForCollaboration(null);
  };

  const handleTeamCollaborationSuccess = () => {
    fetchLeads(); // Refresh leads if needed
    showAlert("success", "Team collaboration created successfully!");
  };

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const derivedFieldsMap = {
    LinkedInCompanyProfile: {
      BasicCostPerMonth: (values) =>
        values.Basic6MonthCost ? values.Basic6MonthCost / 6 : "",
      GrowthCostPerMonth: (values) =>
        values.Growth6MonthCost ? values.Growth6MonthCost / 6 : "",
    },
    BrandProfileManagement: {
      BrandProfilePlanCostPerMonth: (values) =>
        values.BrandProfilePlanCost ? values.BrandProfilePlanCost / 6 : "",
    },
    FoundersLinkedInManagement: {
      BasicCostPerMonth: (values) =>
        values.Basic6MonthCost ? values.Basic6MonthCost / 6 : "",
      GrowthCostPerMonth: (values) =>
        values.Growth6MonthCost ? values.Growth6MonthCost / 6 : "",
    },
    LeadGen: {
      CampaignManagementPerMonth: (values) =>
        values.CampaignManagementThreeMonths
          ? values.CampaignManagementThreeMonths / 3
          : "",
    },
    PersonalBranding: {
      TwoPlatformPerMonth: (values) =>
        values.TwoPlatform6MonthCost ? values.TwoPlatform6MonthCost / 6 : "",
      ThreePlatformPerMonth: (values) =>
        values.ThreePlatform6MonthCost
          ? values.ThreePlatform6MonthCost / 6
          : "",
    },
  };

  // Status display mapping
  const filterStatusMap = {
    hot: "hot",
    warm: "warm",
    closed: "closed",
    dead: "dead",
    meeting: "meeting_scheduled",
    quotation: "quotation_shared",
    quotation_approved: "quotation_approved",
    quotation_rejected: "rejected",
    quotation_revised: "quotation_revised", // 🚨 ADD THIS
    follow_up: "follow-up",
    rescheduled: "rescheduled",
    negotiation: "negotiation",
    payment_overdue: "overdue",
    // 🆕 ADD PAYMENT STATUSES
    token_paid: "token_paid_overdue",
    partially_paid: "partially_paid_overdue",
    fully_paid: "fully_paid",
    payment_pending: "pending",
  };

  // Update the status display mapping
  const statusDisplayMap = {
    hot: "Hot",
    warm: "Warm",
    cold: "Cold",
    closed: "Closed",
    dead: "Dead",
    rescheduled: "Rescheduled",
    quotation_shared: "Quotation Shared",
    quotation_approved: "Quotation Approved",
    quotation_rejected: "Quotation Rejected",
    meeting_scheduled: "Meeting Scheduled",
    call_not_received: "Not Received",
    received: "Received",
    switch_off: "Switch Off",
    wrong_number: "Wrong Number",
    negotiation: "Negotiation",
    "follow-up": "Follow Up",
    rejected: "Rejected",
    fully_paid: "Fully Paid",
    partially_paid: "Partially Paid (Overdue)",
    quotation_expired: "Quotation Expired",
    quotation_revised: "Quotation Revised",
    token_received: "Token Received (Overdue)",
    token_paid: "Token Paid (Overdue)", // 🆕 ADD THIS
    payment_overdue: "Payment Overdue",
    pending: "Payment Pending", // 🆕 ADD THIS
  };
  // Get display status text
  const getDisplayStatus = (status) => {
    return (
      statusDisplayMap[status] ||
      status.charAt(0).toUpperCase() + status.slice(1)
    );
  };

  // Helper function to format date for datetime-local input
  const formatDateTimeForInput = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn("Invalid date provided:", dateString);
        return "";
      }

      // Get local time components directly
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      const formatted = `${year}-${month}-${day}T${hours}:${minutes}`;
      console.log("Formatted datetime:", {
        input: dateString,
        output: formatted,
        local: date.toString(),
      });

      return formatted;
    } catch (error) {
      console.error("Error formatting date:", error, "Input:", dateString);
      return "";
    }
  };

  // Helper function to convert datetime-local value to ISO string for backend
  // Helper function to convert datetime-local value to ISO string for backend
  const convertToISOString = (datetimeLocalValue) => {
    if (!datetimeLocalValue) return "";

    try {
      // Check if it's date-only (YYYY-MM-DD) or datetime (YYYY-MM-DDTHH:mm)
      const isDateOnly = !datetimeLocalValue.includes("T") && !datetimeLocalValue.includes(":");

      if (isDateOnly) {
        // 🚨 For date-only, return just the date string
        return datetimeLocalValue; // Just return "YYYY-MM-DD"
      } else {
        // datetime-local value is in local timezone, convert to ISO string
        const date = new Date(datetimeLocalValue);

        // Check if date is valid
        if (isNaN(date.getTime())) {
          console.warn("Invalid datetime-local value:", datetimeLocalValue);
          return "";
        }

        // Convert to ISO string
        return date.toISOString();
      }
    } catch (error) {
      console.error("Error converting datetime to ISO:", error);
      return "";
    }
  };

  const fileInputRef = useRef(null);
  const [openAddLeadPop, setOpenAddLeadPop] = useState(false);
  const [leadsData, setLeadsData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [companies, setCompanies] = useState([]);

  // state for update status dialog
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [formData, setFormData] = useState({
    callStatus: "",
    leadStatus: "",
    dateTime: "",
    meetingPlatform: "",
    meetingLink: "",
    location: "",
    remarks: "",
    meetingRemarks: "",
    remarksOnStatusChange: "",
    quotationTemplate: "",
    meetingAction: "",
    quotationStatus: "",
    selectedServices: [],
    schedulingAction: "", // Add this for better scheduling control
    quotationData: {
      services: [],
      discount: 0,
      validUntil: "",
      templateUsed: "",
    },
  });

  const [viewRemarksOpen, setViewRemarksOpen] = useState(false);
  const [assignLeadOpen, setAssignLeadOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);

  // Alert states
  const [alert, setAlert] = useState({
    open: false,
    severity: "success",
    message: "",
  });


  const checkLeadHasCollaboration = async (leadId) => {
    try {
      const response = await fetch(
        `${url}/api/team-collaboration/lead/${leadId}/exists`
      );
      const data = await response.json();
      return data.success && data.exists;
    } catch (error) {
      console.error("❌ Error checking collaboration:", error);
      return false;
    }
  };
  const fetchCollaborationParticipants = async (leadId) => {
    try {
      const response = await fetch(
        `${url}/api/team-collaboration/lead/${leadId}/participants?currentUserId=${UID}`
      );
      const data = await response.json();

      if (data.success && Array.isArray(data.participants)) {
        setCollaborationParticipants((prev) => ({
          ...prev,
          [leadId]: data.participants,
        }));
      } else {
        setCollaborationParticipants((prev) => ({
          ...prev,
          [leadId]: [],
        }));
      }
    } catch (error) {
      console.error("❌ Error fetching participants:", error);
      setCollaborationParticipants((prev) => ({
        ...prev,
        [leadId]: [],
      }));
    }
  };

  // Helper function to get participant names for tooltip
  const getCollaborationParticipants = (leadId) => {
    return collaborationParticipants[leadId] || "Loading participants...";
  };

  // Update the fetchCollaborationStatus function to also fetch participants
  const fetchCollaborationStatus = async () => {
    if (!leadsData.length) return;

    try {
      // Parallelize checking collaboration status for all leads
      const collaborationResults = await Promise.all(
        leadsData.map(async (lead) => {
          const hasCollaboration = await checkLeadHasCollaboration(lead._id);
          if (hasCollaboration) {
            await fetchCollaborationParticipants(lead._id);
            return lead._id;
          }
          return null;
        })
      );

      // Filter out nulls and update state once
      const collaborationSet = new Set(collaborationResults.filter(id => id !== null));
      setLeadsWithCollaboration(collaborationSet);
    } catch (error) {
      console.error("❌ Error fetching collaboration status:", error);
    }
  };

  // Call this when leads data changes
  useEffect(() => {
    if (leadsData.length > 0) {
      fetchCollaborationStatus();
    }
  }, [leadsData]);
  const [highlightedLeads, setHighlightedLeads] = useState(new Set());
  const highlightLead = (leadId) => {
    // Add to highlighted set
    setHighlightedLeads((prev) => new Set(prev).add(leadId));

    // Remove after 3 seconds
    setTimeout(() => {
      setHighlightedLeads((prev) => {
        const newSet = new Set(prev);
        newSet.delete(leadId);
        return newSet;
      });
    }, 3000);
  };

  // Check URL parameters for leadId when component mounts
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const leadIdFromUrl = urlParams.get("leadId");

    if (leadIdFromUrl) {
      console.log("🎯 Highlighting lead from URL:", leadIdFromUrl);
      highlightLead(leadIdFromUrl);

      // Clean up URL parameter after processing
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  // Function to check if a lead should be highlighted
  const isLeadHighlighted = (leadId) => {
    return highlightedLeads.has(leadId);
  };

  const handleCreateRevisedQuotation = async () => {
    try {
      // Enhanced validation with better error messages
      if (!selectedLead) {
        console.error("❌ No lead selected");
        showAlert("error", "No lead selected for revision");
        return;
      }

      // Check if we have a quotation to revise
      let quotationToRevise = selectedQuotationForRevision;

      // If no specific quotation selected, try to find the latest one
      if (
        !quotationToRevise &&
        selectedLead.quotations &&
        selectedLead.quotations.length > 0
      ) {
        quotationToRevise =
          selectedLead.quotations[selectedLead.quotations.length - 1];
        console.log(
          "📋 Using latest quotation as fallback:",
          quotationToRevise
        );
      }

      if (!quotationToRevise) {
        console.error("❌ No quotation selected for revision");
        showAlert(
          "error",
          "No quotation found to revise. Please select a quotation or create one first."
        );
        return;
      }

      if (formData.quotationData.services.length === 0) {
        showAlert(
          "error",
          "Please add at least one service to create a revised quotation"
        );
        return;
      }

      setLoading(true);

      const payload = {
        leadId: selectedLead._id,
        originalQuotationId: quotationToRevise._id,
        userId: UID,
        services: formData.quotationData.services,
        discount: parseFloat(formData.quotationData.discount) || 0,
        validUntil: formData.quotationData.validUntil,
        templateUsed: formData.quotationData.templateUsed,
        revisionRemarks: formData.revisionRemarks || "",
        revisionNumber: (quotationToRevise.revisionCount || 0) + 1,
        // 🚨 ADD THIS: Update lead status to quotation_revised
        updateLeadStatus: true,
        newLeadStatus: "quotation_revised",
        callStatus: "received",
        remarks:
          formData.revisionRemarks || "Revised quotation created and shared",
      };

      console.log("📤 Sending revised quotation data:", payload);

      // Call your backend API to create revised quotation
      const response = await fetch(
        `${url}/api/leads/create-revised-quotation`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to create revised quotation");
      }

      console.log("✅ Revised quotation created successfully:", data);
      showAlert(
        "success",
        "Revised quotation created successfully and status updated"
      );

      // Send the revised quotation via email
      try {
        const quotationPromises = formData.quotationData.services.map(
          async (service, index) => {
            const templateName = service.serviceType || "CustomService";

            const templateValues = {
              clientName: selectedLead.clientName,
              clientEmail: selectedLead.email,
              phone: selectedLead.contactNo,
              date: new Date().toLocaleDateString(),
              validUntil: formData.quotationData.validUntil,
              serviceName: service.serviceName,
              serviceTotal: service.calculatedTotal || 0,
              totalAmount: calculateTotalAmount(),
              discount: formData.quotationData.discount || 0,
              finalAmount: calculateFinalAmount(),
              isRevised: true,
              revisionNumber: payload.revisionNumber,
            };

            // Add all service field values
            service.fields.forEach((field) => {
              templateValues[field.name] = field.value || "";
            });

            const quotationPayload = {
              leadId: selectedLead._id,
              userId: UID,
              templateName: templateName,
              values: templateValues,
              serviceIndex: index,
              totalServices: formData.quotationData.services.length,
            };

            console.log(
              `📧 Sending revised quotation for service: ${service.serviceName}`
            );

            const quotationRes = await fetch(
              `${url}/api/templates/send-quotation`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(quotationPayload),
              }
            );

            const quotationData = await quotationRes.json();
            if (!quotationRes.ok) {
              throw new Error(
                `Failed to send quotation for ${service.serviceName}: ${quotationData.message}`
              );
            }

            return {
              serviceName: service.serviceName,
              success: true,
              data: quotationData,
            };
          }
        );

        const results = await Promise.allSettled(quotationPromises);
        const successfulQuotations = results.filter(
          (result) => result.status === "fulfilled" && result.value.success
        );
        const failedQuotations = results.filter(
          (result) => result.status === "rejected"
        );

        if (failedQuotations.length > 0) {
          console.error("Failed quotations:", failedQuotations);
          showAlert(
            "warning",
            `${successfulQuotations.length} quotation(s) sent successfully, but ${failedQuotations.length} failed`
          );
        } else {
          showAlert(
            "success",
            `All ${formData.quotationData.services.length
            } revised quotations have been successfully sent to ${selectedLead.email || "the client"
            }`
          );
        }
      } catch (quotationError) {
        console.error("Quotation sending error:", quotationError);
        showAlert(
          "warning",
          "Revised quotation created but sending failed: " +
          quotationError.message
        );
      }

      // Close dialogs and refresh data
      setRevisionDialogOpen(false);
      handleCloseUpdateDialog();
      fetchLeads(); // This will refresh the lead with new status
    } catch (error) {
      console.error("❌ Error creating revised quotation:", error);
      showAlert("error", error.message);
    } finally {
      setLoading(false);
    }
  };
  // Function to open revision dialog with existing quotation data
  const handleOpenRevisionDialog = async (quotation) => {
    try {
      console.log("📋 Opening revision dialog with quotation:", quotation);

      // If quotation is provided directly, use it
      if (quotation) {
        setSelectedQuotationForRevision(quotation);
        console.log("✅ Using provided quotation for revision");
      }
      // If no quotation provided but we have selectedLead, try to find one
      else if (selectedLead) {
        if (selectedLead.quotations && selectedLead.quotations.length > 0) {
          const latestQuotation =
            selectedLead.quotations[selectedLead.quotations.length - 1];
          setSelectedQuotationForRevision(latestQuotation);
          console.log(
            "✅ Using latest quotation from selected lead:",
            latestQuotation
          );
        } else {
          console.log("❌ No quotations found in selected lead");
          showAlert(
            "error",
            "No quotation found to revise. Please create a quotation first."
          );
          return;
        }
      } else {
        console.log("❌ No quotation provided and no selected lead");
        showAlert("error", "No quotation selected for revision");
        return;
      }

      // Ensure we have a quotation to work with
      if (
        !selectedQuotationForRevision ||
        !selectedQuotationForRevision.services
      ) {
        showAlert("error", "No valid quotation data found");
        return;
      }

      // Pre-populate form with existing quotation data
      const updatedQuotationData = {
        services: selectedQuotationForRevision.services.map(
          (service, index) => {
            console.log("🔄 Processing service:", service);
            return {
              serviceType: service.serviceType,
              serviceName: service.serviceName,
              fields: service.fields.map((field) => ({
                name: field.name,
                label: field.label,
                value: field.value || "",
                type: field.type,
                priceField: field.priceField || false,
                derived: field.derived || false,
                readOnly: field.readOnly || false,
              })),
              calculatedTotal: service.calculatedTotal || 0,
              _id:
                service._id ||
                `service-${Date.now()}-${Math.random()
                  .toString(36)
                  .substr(2, 9)}`,
            };
          }
        ),
        discount: selectedQuotationForRevision.discount || 0,
        validUntil: selectedQuotationForRevision.validUntil
          ? new Date(selectedQuotationForRevision.validUntil)
            .toISOString()
            .split("T")[0]
          : "",
        templateUsed:
          selectedQuotationForRevision.templateUsed || "CustomService",
      };

      console.log("✅ Form data populated with existing quotation");

      setFormData((prev) => ({
        ...prev,
        quotationData: updatedQuotationData,
        revisionRemarks: "",
      }));

      setRevisionDialogOpen(true);
    } catch (error) {
      console.error("❌ Error opening revision dialog:", error);
      showAlert("error", "Failed to load quotation for revision");
    }
  };
  // Function to handle payment recording
  const handleRecordPayment = async () => {
    try {
      if (!selectedQuotation) {
        showAlert("error", "No quotation selected");
        return;
      }

      const response = await fetch(`${url}/api/leads/record`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          quotationId: selectedQuotation._id,
          userId: UID,
          ...paymentForm,
          amount: parseFloat(paymentForm.amount),
        }),
      });

      const data = await response.json();
      if (response.ok) {
        showAlert("success", "Payment recorded successfully");
        setPaymentDialogOpen(false);
        setPaymentForm({
          amount: "",
          paymentType: "advance",
          paymentMethod: "bank_transfer",
          transactionId: "",
          remarks: "",
        });
      } else {
        throw new Error(data.message || "Failed to record payment");
      }
    } catch (error) {
      console.error("Error recording payment:", error);
      showAlert("error", error.message);
    }
  };

  // Function to view quotation details with payments
  const handleViewQuotationDetails = async (quotationId) => {
    try {
      const response = await fetch(
        `${url}/api/quotations/${quotationId}/payments`
      );
      const data = await response.json();

      if (response.ok) {
        // Show quotation details with payment history
        setSelectedQuotation(data);
        setPaymentDialogOpen(true);
      } else {
        throw new Error(data.message || "Failed to fetch quotation details");
      }
    } catch (error) {
      console.error("Error fetching quotation details:", error);
      showAlert("error", error.message);
    }
  };

  const handleDeleteLead = async (leadId) => {
    if (!leadId) return;
    const confirmed = window.confirm(
      "Are you sure you want to delete this lead? This action cannot be undone."
    );
    if (!confirmed) return;

    console.log("🗑️ Deleting lead with ID:", leadId);

    try {
      setLoading(true);
      const res = await fetch(`${url}/api/leads/delete-lead/${leadId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || "Failed to delete lead");
      }

      showAlert("success", "Lead deleted successfully");
      // Refresh the list
      await fetchLeads();
    } catch (err) {
      console.error("❌ Delete lead error:", err);
      showAlert("error", err.message || "Error deleting lead");
    } finally {
      setLoading(false);
    }
  };

  // Service management functions
  // Service management functions - Updated for string _id
  const addServiceToQuotation = (serviceType) => {
    const serviceConfig = ServicesMapping[serviceType];
    if (!serviceConfig) {
      console.error(`Service configuration not found for: ${serviceType}`);
      showAlert("error", `Service configuration not found: ${serviceType}`);
      return;
    }

    const newService = {
      serviceType: serviceType,
      serviceName: serviceConfig.serviceName,
      fields: serviceConfig.fields.map((field) => ({
        name: field.name,
        label: field.label,
        value: field.type === "number" ? 0 : "",
        type: field.type,
        priceField: field.priceField || false,
        derived: field.derived || false,
        readOnly: field.readOnly || false,
      })),
      calculatedTotal: 0,
      _id: `service-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, // String ID
    };

    setFormData((prev) => ({
      ...prev,
      quotationData: {
        ...prev.quotationData,
        services: [...prev.quotationData.services, newService],
      },
    }));
  };

  const removeServiceFromQuotation = (serviceId) => {
    setFormData((prev) => ({
      ...prev,
      quotationData: {
        ...prev.quotationData,
        services: prev.quotationData.services.filter(
          (service) => service._id !== serviceId
        ),
      },
    }));
  };
  const updateServiceField = (serviceId, fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      quotationData: {
        ...prev.quotationData,
        services: prev.quotationData.services.map((service) => {
          if (service._id === serviceId) {
            const updatedFields = service.fields.map((field) =>
              field.name === fieldName ? { ...field, value } : field
            );

            // Calculate derived fields
            const serviceConfig = ServicesMapping[service.serviceType];
            if (!serviceConfig) {
              console.warn(
                `Service config not found for: ${service.serviceType}`
              );
              return { ...service, fields: updatedFields };
            }

            const fieldValues = {};
            updatedFields.forEach((field) => {
              fieldValues[field.name] = field.value;
            });

            if (serviceConfig.calculateDerived) {
              const derivedValues = serviceConfig.calculateDerived(fieldValues);
              const finalFields = updatedFields.map((field) => {
                if (derivedValues[field.name] !== undefined) {
                  return { ...field, value: derivedValues[field.name] };
                }
                return field;
              });

              // Calculate service total
              const calculatedTotal = serviceConfig.calculateServiceTotal
                ? serviceConfig.calculateServiceTotal(fieldValues)
                : 0;

              return {
                ...service,
                fields: finalFields,
                calculatedTotal,
              };
            }

            // Calculate service total even without derived fields
            const calculatedTotal = serviceConfig.calculateServiceTotal
              ? serviceConfig.calculateServiceTotal(fieldValues)
              : 0;

            return {
              ...service,
              fields: updatedFields,
              calculatedTotal,
            };
          }
          return service;
        }),
      },
    }));
  };

  // Calculate totals
  const calculateTotalAmount = () => {
    return formData.quotationData.services.reduce((total, service) => {
      return total + (service.calculatedTotal || 0);
    }, 0);
  };

  const calculateFinalAmount = () => {
    const total = calculateTotalAmount();
    const discount = parseFloat(formData.quotationData.discount) || 0;
    return total - discount;
  };

  // Payment dialog functions
  const handleOpenPaymentDialog = (quotation) => {
    setSelectedQuotation(quotation);
    setPaymentForm({
      amount: "",
      paymentType: "advance",
      paymentMethod: "bank_transfer",
      transactionId: "",
      remarks: "",
    });
    setPaymentDialogOpen(true);
  };

  // const handleRecordPayment = async () => {
  //   try {
  //     if (!selectedLead || !selectedQuotation) {
  //       showAlert('error', 'No lead or quotation selected');
  //       return;
  //     }

  //     const response = await fetch(`${url}/api/leads/record-payment`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         leadId: selectedLead._id,
  //         quotationId: selectedQuotation._id,
  //         userId: UID,
  //         ...paymentForm,
  //         amount: parseFloat(paymentForm.amount)
  //       })
  //     });

  //     const data = await response.json();
  //     if (response.ok) {
  //       showAlert('success', 'Payment recorded successfully');
  //       setPaymentDialogOpen(false);
  //       fetchLeads();
  //     } else {
  //       throw new Error(data.message || 'Failed to record payment');
  //     }
  //   } catch (error) {
  //     console.error('Error recording payment:', error);
  //     showAlert('error', error.message);
  //   }
  // };

  // Theme colors from context
  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.secondary.main;
  const errorColor = theme.palette.error.main;
  const successColor = theme.palette.success.main;
  const redcolor = theme.palette.error.main;
  const greencolor = theme.palette.success.main;

  // Enhanced Status color mapping using theme
  // Enhanced Status color mapping using theme - ADD quotation_revised
  const getStatusColor = (status, leadStatus, lead) => {
    // 🚨 HIGHEST PRIORITY: Payment Overdue gets red background
    const isOverdue =
      status === "payment_overdue" ||
      status === "overdue" ||
      leadStatus === "payment_overdue" ||
      leadStatus === "overdue" ||
      lead?.paymentStatus === "overdue" ||
      lead?.paymentStatus === "payment_overdue" ||
      lead?.paymentStatus === "partially_paid" ||
      lead?.paymentStatus === "token_paid" ||
      lead?.paymentStatus === "token_received" ||
      lead?.status === "payment_overdue" ||
      lead?.leadStatus === "payment_overdue";

    if (isOverdue) {
      return alpha(theme.palette.error.main, 0.2); // Light Red Row
    }

    // Fully Paid - Light Green Row
    if (status === "fully_paid" || leadStatus === "fully_paid" || lead?.paymentStatus === "fully_paid") {
      return alpha(theme.palette.success.main, 0.15);
    }

    // 🚨 SECOND PRIORITY: Use classificationStatus if available
    const classification = lead?.classificationStatus || (["hot", "warm", "cold", "dead", "closed"].includes(status) ? status : null);

    // Warm Leads - Blue (Slightly different or same as per user's current logic)
    if (classification === "warm") {
      return alpha(theme.palette.info.main, 0.3);
    }

    // Closed Leads - Orange
    if (classification === "closed") {
      return alpha(theme.palette.warning.main, 0.2);
    }

    // Dead Leads - Grey
    if (classification === "dead") {
      return alpha(theme.palette.grey[500], 0.2);
    }

    // If no priority classification, fall back to other statuses
    // Quotation Approved - Light Green
    if (status === "quotation_approved") {
      return alpha(theme.palette.success.main, 0.2);
    }

    // Quotation Revised - Light Blue
    if (status === "quotation_revised") {
      return alpha(theme.palette.info.main, 0.2);
    }

    // Quotation Rejected - Light Red
    if (status === "quotation_rejected") {
      return alpha(theme.palette.error.main, 0.2);
    }


    // Meeting Scheduled - Light Purple
    if (status === "meeting_scheduled") {
      return alpha(theme.palette.secondary.main, 0.2);
    }

    // Follow Up - Light Amber
    if (status === "follow-up") {
      return alpha("#f59e0b", 0.2); // Amber color
    }

    // Negotiation - Light Orange
    if (status === "negotiation") {
      return alpha("#f97316", 0.2); // Orange color
    }

    // Rescheduled - Light Indigo
    if (status === "rescheduled") {
      return alpha("#6366f1", 0.2); // Indigo color
    }

    // Quotation Shared - Light Green (but lighter than approved)
    if (status === "quotation_shared") {
      return alpha(theme.palette.success.main, 0.15); // Lighter green
    }

    // Default color
    return "inherit";
  };

  const getStatusChipColor = (status, leadStatus) => {
    if (status === "closed") return "warning";
    if (status === "hot") return "info";
    if (status === "warm") return "info";
    if (status === "dead") return "default";
    if (status === "quotation_approved") return "success";
    if (status === "quotation_revised") return "info";
    if (status === "quotation_rejected") return "error";
    if (status === "payment_overdue" || status === "overdue") return "error";
    if (status === "meeting_scheduled") return "secondary";
    if (status === "follow-up") return "warning";
    if (status === "negotiation") return "warning";
    if (status === "rescheduled") return "info";
    if (status === "quotation_shared") return "success";
    if (status === "token_received" || status === "token_paid") return "success";
    if (status === "partially_paid") return "warning";
    if (status === "fully_paid") return "success";
    if (status === "overdue" || status === "payment_overdue") return "error";
    if (status === "pending" || status === "payment_pending") return "default";
    return "default";
  };

  // Call status icon mapping
  const getCallStatusIcon = (callStatus) => {
    switch (callStatus) {
      case "received":
        return <Phone sx={{ color: successColor, fontSize: 16 }} />;
      case "call_not_received":
        return <PhoneDisabled sx={{ color: errorColor, fontSize: 16 }} />;
      case "switch_off":
        return <PhoneCallback sx={{ color: "orange", fontSize: 16 }} />;
      case "wrong_number":
        return <PhoneForwarded sx={{ color: "red", fontSize: 16 }} />;
      default:
        return <Phone sx={{ color: "grey", fontSize: 16 }} />;
    }
  };

  const getCallStatusText = (callStatus) => {
    return statusDisplayMap[callStatus] || callStatus;
  };

  // Fetch companies for superAdmin
  const fetchCompanies = async () => {
    if (userRole !== "superAdmin") return;

    try {
      const response = await fetch(`${url}/api/company/fetch-companies`);
      const data = await response.json();
      if (data.data) {
        setCompanies(data.data);
      }
    } catch (error) {
      console.error("❌ Error fetching companies:", error);
      showAlert("error", "Failed to fetch companies");
    }
  };

  const handleOpenFile = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please choose a CSV file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", UID); // your actual user
    formData.append("companyId", CID); // optional

    try {
      setLoading(true);

      const res = await fetch(`${url}/api/import/add-leads`, {
        method: "POST",
        body: formData, // 🔥 DO NOT add Content-Type
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.message || "Upload failed");
        return;
      }

      setMessage(data.message);
    } catch (error) {
      setMessage("Network error");
    } finally {
      setLoading(false);
      fileInputRef.current.value = ""; // reset file input
      setFile(null);
    }
  };

  // Fetch leads based on role
  // const fetchLeads = async () => {
  //   try {
  //     setLoading(true);

  //     let fetchUrl = `${url}/api/leads/fetch-leads?userId=${UID}&role=${userRole}`;

  //     if (userRole === "admin" && CID) {
  //       fetchUrl += `&companyId=${CID}`;
  //     } else if (userRole === "superAdmin" && companyFilter !== "all") {
  //       fetchUrl += `&companyId=${companyFilter}`;
  //     }

  //     if (dateFilter !== "all") {
  //       fetchUrl += `&date=${selectedDate}`;
  //     }

  //     const response = await fetch(fetchUrl);
  //     const data = await response.json();

  //     if (data.data) {
  //       setLeadsData(data.data);
  //     } else {
  //       setLeadsData([]);
  //     }
  //   } catch (error) {
  //     console.error("❌ Error fetching leads:", error);
  //     setLeadsData([]);
  //     showAlert("error", "Failed to fetch leads");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Enhanced fetchLeads function - Remove date parameter from API call
  const fetchLeads = async () => {
    try {
      setLoading(true);

      let fetchUrl = `${url}/api/leads/fetch-leads?userId=${UID}&role=${userRole}`;

      if (userRole === "admin" && CID) {
        fetchUrl += `&companyId=${CID}`;
      } else if (userRole === "superAdmin" && companyFilter !== "all") {
        fetchUrl += `&companyId=${companyFilter}`;
      }

      if (searchQuery) {
        fetchUrl += `&search=${encodeURIComponent(searchQuery)}`;
      }

      // Remove date parameter - we'll filter on frontend
      const response = await fetch(fetchUrl);
      const data = await response.json();

      if (data.data) {
        setLeadsData(data.data);
      } else {
        setLeadsData([]);
      }
    } catch (error) {
      console.error("❌ Error fetching leads:", error);
      setLeadsData([]);
      showAlert("error", "Failed to fetch leads");
    } finally {
      setLoading(false);
    }
  };

  // Add date helper functions
  const getStartOfDay = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  };


  const getEndOfDay = (date) => {
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59, 999);
    return newDate;
  };
  const formatDate = (dateValue) => {
    if (!dateValue) return "N/A";

    let date;

    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      const [year, month, day] = dateValue.split('-').map(Number);
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(dateValue);
    }

    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  // const isSameDay = (date1, date2) => {
  //   if (!date1 || !date2) return false;
  //   return getStartOfDay(date1).getTime() === getStartOfDay(date2).getTime();
  // };
  // Helper function to get when lead was marked terminal

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;

    const d1 = getStartOfDay(date1);
    const d2 = getStartOfDay(date2);

    return d1.getTime() === d2.getTime();
  };


  const getLeadTerminalDate = (lead) => {
    // Try to find when the lead was marked terminal from status records
    if (lead.statusRecords && lead.statusRecords.length > 0) {
      const terminalRecord = lead.statusRecords
        .slice()
        .reverse()
        .find(
          (record) =>
            record.status === "dead" ||
            record.status === "closed" ||
            record.status === "fully_paid"
        );

      if (terminalRecord && terminalRecord.updatedAt) {
        return new Date(terminalRecord.updatedAt);
      }
    }

    // Fallback to leadCallDate or updatedAt
    return new Date(lead.leadCallDate || lead.updatedAt);
  };

  // Keep getLeadDeadDate as an alias for backward
  const getLeadDeadDate = (lead) => {
    return getLeadTerminalDate(lead);
  };

  // const shouldLeadBeShownOnDate = (lead, targetDate, dateFilter) => {
  //   const leadCallDate = lead.leadCallDate ? new Date(lead.leadCallDate) : null;
  //   const targetDayStart = getStartOfDay(targetDate);

  //   if (!leadCallDate) return false;

  //   if (lead.status === "new" && lead.leadStatus === "new") {
  //     if (dateFilter === "today") {
  //       const todayStart = getStartOfDay(new Date());
  //       // Show if scheduled for today OR if it's from past (carry forward)
  //       if (isSameDay(leadCallDate, targetDate)) {
  //         return true; // Scheduled for today
  //       }
  //       if (leadCallDate < todayStart) {
  //         console.log(
  //           `📋 Unattended lead carry forward: ${
  //             lead.clientName
  //           } (original: ${formatDate(leadCallDate)})`
  //         );
  //         return true; // Carry forward from past
  //       }
  //     }
  //     return false;
  //   }

  //   // ===== RULE 1: Terminal statuses ONLY show on their actual terminal date =====
  //   const terminalStatuses = ["dead", "closed", "fully_paid"];
  //   if (terminalStatuses.includes(lead.status)) {
  //     const terminalDate = getLeadTerminalDate(lead);
  //     const isTerminalDay = isSameDay(terminalDate, targetDate);
  //     console.log(
  //       `💀 Terminal lead ${
  //         lead.clientName
  //       }: shows=${isTerminalDay} on ${formatDate(
  //         targetDate
  //       )} (terminal on ${formatDate(terminalDate)})`
  //     );
  //     return isTerminalDay;
  //   }

  //   // ===== RULE 2: Meeting scheduled - Show on meeting date AND carry forward if not completed =====
  //   if (lead.status === "meeting_scheduled" && lead.meeting?.dateTime) {
  //     const meetingDate = getStartOfDay(new Date(lead.meeting.dateTime));
  //     const isMeetingDay = meetingDate.getTime() === targetDayStart.getTime();

  //     // For TODAY filter: Show if it's meeting day OR meeting has passed but status not updated
  //     if (dateFilter === "today") {
  //       const todayStart = getStartOfDay(new Date());
  //       const meetingHasPassed = meetingDate < todayStart;

  //       if (isMeetingDay) {
  //         console.log(`📅 Meeting today: ${lead.clientName}`);
  //         return true;
  //       } else if (meetingHasPassed) {
  //         // 🚨 CARRY FORWARD: Meeting passed but status still "meeting_scheduled"
  //         console.log(
  //           `🚨 Meeting overdue - carry forward: ${
  //             lead.clientName
  //           } (meeting was on ${formatDate(lead.meeting.dateTime)})`
  //         );
  //         return true;
  //       }
  //       return false;
  //     }

  //     // For other date filters: Only show on exact meeting date
  //     console.log(
  //       `📅 Meeting lead ${
  //         lead.clientName
  //       }: shows=${isMeetingDay} on ${formatDate(targetDate)}`
  //     );
  //     return isMeetingDay;
  //   }

  //   // ===== RULE 3: For TODAY filter - Show scheduled + carry forward non-terminal leads =====
  //   if (dateFilter === "today") {
  //     const todayStart = getStartOfDay(new Date());

  //     const isScheduledForToday = isSameDay(leadCallDate, targetDate);
  //     const isFromPreviousDate = leadCallDate < todayStart;

  //     if (isScheduledForToday) {
  //       console.log(
  //         `📅 Scheduled today: ${lead.clientName} (original date: ${formatDate(
  //           leadCallDate
  //         )})`
  //       );
  //       return true;
  //     }

  //     if (isFromPreviousDate && !terminalStatuses.includes(lead.status)) {
  //       // 🚨 CARRY FORWARD with ORIGINAL DATE
  //       console.log(
  //         `📅 Carry forward: ${lead.clientName} (${
  //           lead.status
  //         }) with original date ${formatDate(lead.leadCallDate)}`
  //       );
  //       return true;
  //     }

  //     return false;
  //   }

  //   // ===== RULE 4: For TOMORROW filter - Only show scheduled leads =====
  //   if (dateFilter === "tomorrow") {
  //     const isScheduledForTomorrow = isSameDay(leadCallDate, targetDate);
  //     console.log(
  //       `🔮 Tomorrow lead ${
  //         lead.clientName
  //       }: shows=${isScheduledForTomorrow} (scheduled: ${formatDate(
  //         leadCallDate
  //       )})`
  //     );
  //     return isScheduledForTomorrow;
  //   }

  //   // ===== RULE 5: For YESTERDAY filter - Show only leads from yesterday =====
  //   if (dateFilter === "yesterday") {
  //     const isFromYesterday = isSameDay(leadCallDate, targetDate);
  //     console.log(
  //       `📚 Yesterday lead ${
  //         lead.clientName
  //       }: shows=${isFromYesterday} (original: ${formatDate(leadCallDate)})`
  //     );
  //     return isFromYesterday;
  //   }

  //   // ===== RULE 6: For CUSTOM dates - Show only leads scheduled for that date =====
  //   if (dateFilter === "custom") {
  //     const isScheduledForCustom = isSameDay(leadCallDate, targetDate);
  //     console.log(
  //       `📋 Custom date lead ${
  //         lead.clientName
  //       }: shows=${isScheduledForCustom} (original: ${formatDate(
  //         leadCallDate
  //       )})`
  //     );
  //     return isScheduledForCustom;
  //   }

  //   // ===== RULE 7: For ALL filter - Show all leads =====
  //   if (dateFilter === "all") {
  //     console.log(
  //       `🌍 All leads: ${lead.clientName} shows=true (original: ${formatDate(
  //         leadCallDate
  //       )})`
  //     );
  //     return true;
  //   }

  //   return false;
  // };
  // Add helper function to get approval date





  // const shouldLeadBeShownOnDate = (lead, targetDate, dateFilter) => {
  //   const targetDayStart = getStartOfDay(targetDate);
  //   const todayStart = getStartOfDay(new Date());

  //   // Helper to parse date
  //   const parseLeadDate = (dateValue) => {
  //     if (!dateValue) return null;

  //     if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
  //       const [year, month, day] = dateValue.split('-').map(Number);
  //       return new Date(year, month - 1, day);
  //     }

  //     try {
  //       const date = new Date(dateValue);
  //       return isNaN(date.getTime()) ? null : date;
  //     } catch (error) {
  //       return null;
  //     }
  //   };

  //   const leadDate = parseLeadDate(lead.leadCallDate);
  //   if (!leadDate) return false;

  //   const isScheduledForTargetDay = isSameDay(leadDate, targetDate);
  //   const isToday = targetDayStart.getTime() === todayStart.getTime();

  //   // ===== CASE 1: Terminal Statuses (closed, dead) =====
  //   const terminalStatuses = ["dead", "closed"];
  //   if (terminalStatuses.includes(lead.status)) {
  //     // Try to find when the status changed to terminal
  //     const terminalChangeDate = getTerminalStatusChangeDate(lead);

  //     // Only show on the exact day when status changed to terminal
  //     if (terminalChangeDate) {
  //       const isTerminalChangeDay = isSameDay(terminalChangeDate, targetDate);
  //       console.log(`💀 Terminal lead ${lead.clientName}: shows=${isTerminalChangeDay} (terminal on ${formatDate(terminalChangeDate)})`);
  //       return isTerminalChangeDay;
  //     }

  //     // Fallback: Show on leadCallDate if we can't find terminal change date
  //     return isScheduledForTargetDay;
  //   }

  //   // ===== CASE 2: Scheduled Statuses =====
  //   const scheduledStatuses = ["rescheduled", "meeting_scheduled", "token_paid", "partially_paid", "payment_overdue"];

  //   if (scheduledStatuses.includes(lead.status)) {
  //     // Get the scheduled date for this status
  //     const scheduledDate = getScheduledDateForStatus(lead);

  //     if (!scheduledDate) {
  //       // If no scheduled date, show on today (when status was changed)
  //       return isToday;
  //     }

  //     const isScheduledDay = isSameDay(scheduledDate, targetDate);
  //     const isStatusChangeDay = isToday;

  //     // Show on: 
  //     // 1. Today (when status was changed)
  //     // 2. The scheduled date (if different from today)
  //     // 3. NOT on dates in between
  //     return isStatusChangeDay || isScheduledDay;
  //   }

  //   // ===== CASE 3: Non-scheduled Statuses =====
  //   const nonScheduledStatuses = [
  //     "quotation_shared", 
  //     "quotation_approved", 
  //     "quotation_rejected", 
  //     "quotation_revised", 
  //     "fully_paid",
  //     "negotiation",
  //     "follow-up",
  //     "hot",
  //     "warm",
  //     "new"
  //   ];

  //   if (nonScheduledStatuses.includes(lead.status)) {
  //     // Get when this status was applied
  //     const statusChangeDate = getStatusChangeDate(lead, lead.status);

  //     if (!statusChangeDate) {
  //       // If we can't find when status changed, show based on lead date
  //       return isScheduledForTargetDay || (dateFilter === "today" && leadDate < todayStart);
  //     }

  //     // For non-scheduled statuses, show from status change date onward
  //     const statusChangeStart = getStartOfDay(statusChangeDate);
  //     const shouldShowFromStatusChange = targetDayStart >= statusChangeStart;

  //     // Also show if it's today's scheduled date
  //     const isOriginalScheduledDate = isScheduledForTargetDay;

  //     return shouldShowFromStatusChange || isOriginalScheduledDate;
  //   }

  //   // ===== Default logic for TODAY filter =====
  //   if (dateFilter === "today") {
  //     const isFromPreviousDate = leadDate < todayStart;

  //     // For TODAY filter, show scheduled leads + carry forward non-terminal leads
  //     if (isScheduledForTargetDay) {
  //       return true;
  //     }

  //     // Carry forward from previous dates
  //     if (isFromPreviousDate && 
  //         !terminalStatuses.includes(lead.status) && 
  //         !scheduledStatuses.includes(lead.status)) {
  //       return true;
  //     }

  //     return false;
  //   }

  //   // ===== For other date filters =====
  //   if (dateFilter === "tomorrow" || dateFilter === "yesterday" || dateFilter === "custom") {
  //     return isScheduledForTargetDay;
  //   }

  //   // ===== For ALL filter =====
  //   if (dateFilter === "all") {
  //     return true;
  //   }

  //   return false;

  // };
  const parseLeadDate = (dateValue) => {
    if (!dateValue) return null;

    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      const [year, month, day] = dateValue.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    try {
      const date = new Date(dateValue);
      return isNaN(date.getTime()) ? null : date;
    } catch (error) {
      return null;
    }
  };
  // const shouldLeadBeShownOnDate = (lead, targetDate, dateFilter) => {
  //   const targetDayStart = getStartOfDay(targetDate);
  //   const todayStart = getStartOfDay(new Date());

  //   const isToday = targetDayStart.getTime() === todayStart.getTime();

  //   // ===== CASE 1: Terminal Statuses (closed, dead) =====
  //   const terminalStatuses = ["dead", "closed"];
  //   if (terminalStatuses.includes(lead.status)) {
  //     const terminalChangeDate = getTerminalStatusChangeDate(lead);
  //     if (terminalChangeDate) {
  //       return isSameDay(terminalChangeDate, targetDate);
  //     }
  //     return false;
  //   }

  //   // ===== CASE 2: Scheduled Statuses =====
  //   const scheduledStatuses = ["rescheduled", "meeting_scheduled", "token_paid", "partially_paid", "payment_overdue"];

  //   if (scheduledStatuses.includes(lead.status)) {
  //     // Get the scheduled date for this status
  //     const scheduledDate = getScheduledDateForDisplay(lead);

  //     // Get when this status was applied
  //     const statusChangeDate = getStatusChangeDate(lead, lead.status);
  //     const isStatusChangeDay = statusChangeDate ? isSameDay(statusChangeDate, targetDate) : false;

  //     const isScheduledDay = scheduledDate ? isSameDay(scheduledDate, targetDate) : false;

  //     // 🚨 CRITICAL: For scheduled statuses, show on BOTH:
  //     // 1. Status change date (when status was applied)
  //     // 2. Scheduled date (when action should happen)
  //     // 3. NOT on dates in between

  //     if (dateFilter === "today") {
  //       const scheduledHasPassed = scheduledDate && scheduledDate < todayStart;
  //       return isStatusChangeDay || isScheduledDay || scheduledHasPassed;
  //     }

  //     return isStatusChangeDay || isScheduledDay;
  //   }

  //   // ===== CASE 3: Non-scheduled Statuses =====
  //   const nonScheduledStatuses = [
  //     "quotation_shared", "quotation_approved", "quotation_rejected", 
  //     "quotation_revised", "fully_paid", "negotiation", "follow-up", 
  //     "hot", "warm", "new"
  //   ];

  //   if (nonScheduledStatuses.includes(lead.status)) {
  //     const statusChangeDate = getStatusChangeDate(lead, lead.status);

  //     if (!statusChangeDate) {
  //       const leadDate = parseLeadDate(lead.leadCallDate);
  //       return leadDate ? isSameDay(leadDate, targetDate) || (dateFilter === "today" && leadDate < todayStart) : false;
  //     }

  //     const statusChangeStart = getStartOfDay(statusChangeDate);
  //     const shouldShowFromStatusChange = targetDayStart >= statusChangeStart;

  //     return shouldShowFromStatusChange;
  //   }

  //   // ===== Default logic =====
  //   if (dateFilter === "today") {
  //     const leadDate = parseLeadDate(lead.leadCallDate);
  //     if (!leadDate) return false;

  //     const isScheduledForToday = isSameDay(leadDate, targetDate);
  //     const isFromPreviousDate = leadDate < todayStart;

  //     if (isScheduledForToday) return true;

  //     if (isFromPreviousDate && 
  //         !terminalStatuses.includes(lead.status) && 
  //         !scheduledStatuses.includes(lead.status)) {
  //       return true;
  //     }

  //     return false;
  //   }

  //   if (dateFilter === "tomorrow" || dateFilter === "yesterday" || dateFilter === "custom") {
  //     const leadDate = parseLeadDate(lead.leadCallDate);
  //     return leadDate ? isSameDay(leadDate, targetDate) : false;
  //   }

  //   if (dateFilter === "all") {
  //     return true;
  //   }

  //   return false;
  // };

  // Updated helper to get scheduled date for display AND filtering

  const shouldLeadBeShownOnDate = (lead, targetDate, dateFilter) => {
    // Basic date calculations
    const targetDayStart = getStartOfDay(targetDate);
    const todayStart = getStartOfDay(new Date());

    // 1. Define Status Groups
    const SCHEDULING_STATUSES = ["rescheduled", "meeting_scheduled"];
    const PAYMENT_STATUSES = ["token_paid", "partially_paid", "payment_overdue", "overdue", "token_received", "fully_paid"];
    const TERMINAL_STATUSES = ["dead", "closed"]; // Update day only, no carry forward
    const CARRY_FORWARD_STATUSES = [
      "quotation_shared", "quotation_approved", "quotation_rejected",
      "quotation_revised", "fully_paid", "negotiation", "follow-up",
      "hot", "warm", "new", "call_not_received", "switch_off", "wrong_number"
    ];

    // Identify active logic type based on multiple statuses
    // Priority 1: Scheduling
    const activeSchedulingStatus = [lead.schedulingStatus, lead.status, lead.classificationStatus]
      .find(s => SCHEDULING_STATUSES.includes(s));

    // Priority 2: Payment
    const activePaymentStatus = [lead.status, lead.classificationStatus, lead.paymentStatus]
      .find(s => PAYMENT_STATUSES.includes(s));

    // Priority 3: Terminal (Dead/Closed)
    const isTerminal = TERMINAL_STATUSES.includes(lead.status) || TERMINAL_STATUSES.includes(lead.classificationStatus);

    // --- APPLY BUSINESS RULES BY PRIORITY ---

    // 1. Get the primary target date for this lead
    const scheduledDate = getScheduledDateForDisplay(lead);
    const targetDateStart = scheduledDate ? getStartOfDay(scheduledDate) : null;
    const isFutureDate = targetDateStart ? targetDateStart > todayStart : false;
    const isScheduledForTargetDay = targetDateStart ? targetDateStart.getTime() === targetDayStart.getTime() : false;

    // 2. Identify the status change date
    const currentStatus = activePaymentStatus || activeSchedulingStatus ||
      ((lead.classificationStatus && lead.classificationStatus !== 'none') ? lead.classificationStatus : lead.status);
    const statusChangeDate = getStatusChangeDate(lead, currentStatus);

    // 🚨 KEY FIX: Check if lead was updated TODAY (for real-time confirmation)
    const isUpdatedToday = lead.updatedAt ? isSameDay(new Date(lead.updatedAt), targetDate) : false;
    const isStatusChangeDay = statusChangeDate ? isSameDay(statusChangeDate, targetDate) : false;

    // RULE: If there is a FUTURE date, apply STRICT visibility (Only Update Day + Target Day)
    if (isFutureDate && dateFilter !== "all") {
      const show = isUpdatedToday || isStatusChangeDay || isScheduledForTargetDay;
      console.log(`🔍 [${lead.clientName}] Strict Logic (Future Date: ${formatDate(scheduledDate)}): ${show} (Update: ${isUpdatedToday}, Status: ${isStatusChangeDay}, Target: ${isScheduledForTargetDay} for filter: ${dateFilter})`);
      return show;
    }

    // RULE: If it's a TERMINAL lead (Dead/Closed), only show on the day it was updated
    if (isTerminal && dateFilter !== "all") {
      const terminalChangeDate = getTerminalStatusChangeDate(lead);
      return terminalChangeDate ? isSameDay(terminalChangeDate, targetDate) : false;
    }

    // RULE: For PASSED or NO scheduled date, use CARRY FORWARD logic
    if (CARRY_FORWARD_STATUSES.includes(currentStatus) ||
      activePaymentStatus ||
      activeSchedulingStatus ||
      dateFilter === "all") {

      if (dateFilter === "all") return true;

      // For leads with a past/present scheduled date, show from the update day onwards (Carry Forward)
      if (statusChangeDate) {
        const statusChangeStart = getStartOfDay(statusChangeDate);
        return targetDayStart >= statusChangeStart;
      }

      // Final fallback to lead creation date
      const leadDate = parseLeadDate(lead.leadCallDate);
      if (!leadDate) return false;
      const leadDateStart = getStartOfDay(leadDate);
      return targetDayStart >= leadDateStart;
    }

    return false;
  };
  const getPrimaryTargetDate = (lead) => {
    if (!lead) return { date: null, label: "" };

    // 🚨 RULE: For fully paid leads, show leadCallDate only IF they are not actively rescheduled/meeting
    if ((lead.status === "fully_paid" || lead.paymentStatus === "fully_paid") &&
      lead.status !== "rescheduled" &&
      lead.status !== "meeting_scheduled" &&
      lead.schedulingStatus !== "rescheduled" &&
      lead.schedulingStatus !== "meeting_scheduled") {
      return {
        date: lead.leadCallDate ? new Date(lead.leadCallDate) : null,
        label: ""
      };
    }

    const candidates = [];
    const todayStart = getStartOfDay(new Date());

    // 1. Next Payment Date
    const nextPayment = getNextPaymentDate(lead);
    if (nextPayment) {
      candidates.push({
        date: new Date(nextPayment),
        label: "Next payment"
      });
    }

    // 2. Meeting Date
    if (lead.meeting?.dateTime) {
      candidates.push({
        date: new Date(lead.meeting.dateTime),
        label: "Meeting on"
      });
    }

    // 3. Rescheduled Date
    if (lead.rescheduledDate) {
      candidates.push({
        date: new Date(lead.rescheduledDate),
        label: "Rescheduled to"
      });
    }

    const leadCallDate = lead.leadCallDate ? new Date(lead.leadCallDate) : null;

    if (candidates.length === 0) {
      return {
        date: leadCallDate,
        label: ""
      };
    }

    // Sort by date descending to find the LATEST date
    candidates.sort((a, b) => b.date.getTime() - a.date.getTime());

    const topCandidate = candidates[0];

    // 🚨 CONTEXTUAL PRIORITY LOGIC
    // If the top candidate is in the FUTURE, use it.
    if (topCandidate.date.getTime() >= todayStart.getTime()) {
      return topCandidate;
    }

    // If candidate is in the PAST, check if leadCallDate is MORE RECENT (e.g., Today)
    if (leadCallDate && leadCallDate.getTime() > topCandidate.date.getTime()) {
      return {
        date: leadCallDate,
        label: "" // Clear label like "Meeting on" if we are showing today's manual update date
      };
    }

    return topCandidate;
  };

  const getScheduledDateForDisplay = (lead) => {
    console.log("📅 Getting primary scheduled date for lead:", lead._id, lead.clientName);
    const { date } = getPrimaryTargetDate(lead);

    // If the picked date is roughly equal to leadCallDate and not in future, return null
    // (This helps shouldLeadBeShownOnDate's fallback logic)
    const leadDate = lead.leadCallDate ? new Date(lead.leadCallDate) : null;
    if (date && leadDate && isSameDay(date, leadDate) && date <= new Date()) {
      // Check if it's strictly one of the target types
      if (!getNextPaymentDate(lead) && !lead.meeting?.dateTime && !lead.rescheduledDate) {
        return null;
      }
    }

    return date;
  };
  // Helper function to get when status changed to terminal
  const getTerminalStatusChangeDate = (lead) => {
    // 1. Check explicit terminal status fields (highest accuracy)
    if (lead.terminalStatus?.terminalDate) return new Date(lead.terminalStatus.terminalDate);
    if (lead.closed?.closedDate) return new Date(lead.closed.closedDate);

    // 2. Check status records
    if (lead.statusRecords && lead.statusRecords.length > 0) {
      // Find the record where status changed to terminal (checking both legacy and new names)
      const terminalRecord = lead.statusRecords
        .slice()
        .reverse()
        .find(record => ["dead", "closed"].includes(record.status) || ["dead", "closed"].includes(record.classificationStatus));

      if (terminalRecord && terminalRecord.updatedAt) {
        return new Date(terminalRecord.updatedAt);
      }
    }

    // Fallback to leadCallDate
    return lead.leadCallDate ? new Date(lead.leadCallDate) : null;
  };

  // Helper function to get scheduled date based on status
  const getScheduledDateForStatus = (lead) => {
    switch (lead.status) {
      case "rescheduled":
        return lead.rescheduledDate ? new Date(lead.rescheduledDate) : null;

      case "meeting_scheduled":
        return lead.meeting?.dateTime ? new Date(lead.meeting.dateTime) : null;

      case "token_paid":
      case "partially_paid":
      case "payment_overdue":
        // Check for next payment date in quotations
        if (lead.quotations && lead.quotations.length > 0) {
          const latestQuotation = lead.quotations[lead.quotations.length - 1];
          if (latestQuotation.payments && latestQuotation.payments.length > 0) {
            const latestPayment = latestQuotation.payments[latestQuotation.payments.length - 1];
            if (latestPayment.nextPaymentDate) {
              return new Date(latestPayment.nextPaymentDate);
            }
          }
        }
        return null;

      default:
        return null;
    }
  };
  // Helper function to get the correct display date based on lead status
  const getDisplayDateForLead = (lead) => {
    if (!lead) return null;
    return getPrimaryTargetDate(lead).date;
  };

  // Helper to get next payment date for payment-related leads
  // Helper to get next payment date for payment-related leads
  const getNextPaymentDate = (lead) => {
    console.log("💳 Getting next payment date for lead:", lead._id, lead.status);

    // Check if lead has payments in its latest quotation
    if (lead.quotations && lead.quotations.length > 0) {
      const latestQuotation = lead.quotations[lead.quotations.length - 1];
      console.log("📋 Latest quotation:", {
        quotationId: latestQuotation._id,
        status: lead.status,
        paymentStatus: latestQuotation.paymentStatus,
        payments: latestQuotation.payments
      });

      if (latestQuotation.payments && latestQuotation.payments.length > 0) {
        // For payment-related statuses, get the NEXT payment date (not the last)
        const allPayments = latestQuotation.payments
          .filter(p => p.nextPaymentDate)
          .sort((a, b) => new Date(a.nextPaymentDate) - new Date(b.nextPaymentDate));

        // Find the next payment date that's in the future or today
        const today = getStartOfDay(new Date());
        const nextPayment = allPayments.find(p =>
          getStartOfDay(new Date(p.nextPaymentDate)) >= today
        );

        if (nextPayment) {
          const nextDate = new Date(nextPayment.nextPaymentDate);
          console.log("📅 Found next payment date:", nextDate);
          return nextDate;
        }

        // If no future payments, get the most recent one
        if (allPayments.length > 0) {
          const lastPayment = allPayments[allPayments.length - 1];
          const lastDate = new Date(lastPayment.nextPaymentDate);
          console.log("📅 Using last payment date:", lastDate);
          return lastDate;
        }
      }

      // Check if quotation has a next payment date field
      if (latestQuotation.nextPaymentDate) {
        const nextDate = new Date(latestQuotation.nextPaymentDate);
        console.log("📅 Next payment date from quotation field:", nextDate);
        return nextDate;
      }
    }

    console.log("ℹ️ No next payment date found");
    return null;
  };

  // Helper to get date type label
  const getDateTypeLabel = (lead) => {
    return getPrimaryTargetDate(lead).label;
  };
  // Helper function to get when a specific status was applied
  // const getStatusChangeDate = (lead, status) => {
  //   if (lead.statusRecords && lead.statusRecords.length > 0) {
  //     // Find the first record with this status (most recent)
  //     const statusRecord = lead.statusRecords
  //       .slice()
  //       .reverse()
  //       .find(record => record.status === status);

  //     if (statusRecord && statusRecord.updatedAt) {
  //       return new Date(statusRecord.updatedAt);
  //     }
  //   }

  //   // If lead already has this status, use leadCallDate
  //   if (lead.status === status && lead.leadCallDate) {
  //     return new Date(lead.leadCallDate);
  //   }

  //   return null;
  // };
  const getStatusChangeDate = (lead, status) => {
    console.log(` Getting change date for status: ${status} in lead: ${lead.clientName}`);

    // SPECIAL FIX: For rescheduled status, check reschedulingHistory FIRST
    if (status === "rescheduled" && lead.reschedulingHistory && lead.reschedulingHistory.length > 0) {
      console.log(` Rescheduling history for ${lead.clientName}:`, lead.reschedulingHistory);

      // Find rescheduling record that matches current leadCallDate
      // This ensures we get the correct rescheduling date for current leadCallDate
      const matchingReschedule = lead.reschedulingHistory.find(record => {
        const rescheduledAt = new Date(record.rescheduledAt);
        const rescheduledAtDate = rescheduledAt.toISOString().split('T')[0];
        const leadCallDateStr = typeof lead.leadCallDate === 'string'
          ? lead.leadCallDate
          : new Date(lead.leadCallDate).toISOString().split('T')[0];

        console.log(`    Checking record: rescheduledAt=${rescheduledAtDate}, leadCallDate=${leadCallDateStr}`);
        return rescheduledAtDate === leadCallDateStr;
      });

      if (matchingReschedule && matchingReschedule.rescheduledAt) {
        console.log(` Found matching reschedule date in history: ${formatDate(matchingReschedule.rescheduledAt)}`);
        return new Date(matchingReschedule.rescheduledAt);
      }

      // Fallback: if no matching record found, use most recent one
      const latestReschedule = lead.reschedulingHistory[lead.reschedulingHistory.length - 1];
      if (latestReschedule && latestReschedule.rescheduledAt) {
        console.log(` Using latest reschedule date in history: ${formatDate(latestReschedule.rescheduledAt)}`);
        return new Date(latestReschedule.rescheduledAt);
      }
    }

    // For other statuses, check statusRecords
    if (lead.statusRecords && lead.statusRecords.length > 0) {
      // Sort by updatedAt descending to get most recent
      const sortedRecords = [...lead.statusRecords].sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      );

      // Find the record where this status was set (checking all possible field names)
      const statusRecord = sortedRecords.find(record =>
        record.status === status ||
        record.classificationStatus === status ||
        record.schedulingStatus === status ||
        record.quotationStatus === status ||
        (status === 'fully_paid' && (record.status === 'fully_paid' || record.paymentStatus === 'fully_paid')) ||
        (status === 'overdue' && (record.status === 'payment_overdue' || record.paymentStatus === 'overdue'))
      );

      if (statusRecord && statusRecord.updatedAt) {
        console.log(` Found status change date in records for ${status}: ${formatDate(statusRecord.updatedAt)}`);
        return new Date(statusRecord.updatedAt);
      }
    }

    // Check updatedAt if the current status matches
    if (lead.status === status && lead.updatedAt) {
      console.log(` Using lead.updatedAt: ${formatDate(lead.updatedAt)}`);
      return new Date(lead.updatedAt);
    }

    // For payment statuses, check payment dates
    if (["token_paid", "partially_paid", "payment_overdue"].includes(status)) {
      if (lead.quotations && lead.quotations.length > 0) {
        const latestQuotation = lead.quotations[lead.quotations.length - 1];
        if (latestQuotation.payments && latestQuotation.payments.length > 0) {
          // Find payment with this status
          const payment = latestQuotation.payments
            .sort((a, b) => new Date(b.paymentDate) - new Date(a.paymentDate))
            .find(p => {
              // Map payment type to status
              if (p.paymentType === "token" && status === "token_paid") return true;
              if (p.paymentType === "installment" && status === "partially_paid") return true;
              if (p.paymentStatus === "overdue" && status === "payment_overdue") return true;
              return false;
            });

          if (payment && payment.paymentDate) {
            console.log(`📅 Found payment date: ${formatDate(payment.paymentDate)}`);
            return new Date(payment.paymentDate);
          }
        }
      }
    }

    // Fallback to leadCallDate
    if (lead.leadCallDate) {
      console.log(`📅 Fallback to leadCallDate: ${formatDate(lead.leadCallDate)}`);
      return new Date(lead.leadCallDate);
    }

    console.log(`❌ No status change date found`);
    return null;
  };
  const getLeadApprovalDate = (lead) => {
    // Try to find when the lead was approved from status records
    if (lead.statusRecords && lead.statusRecords.length > 0) {
      const approvalRecord = lead.statusRecords
        .slice()
        .reverse()
        .find((record) => record.status === "quotation_approved");

      if (approvalRecord && approvalRecord.updatedAt) {
        return new Date(approvalRecord.updatedAt);
      }
    }

    // Fallback to updatedAt or leadCallDate
    return new Date(lead.updatedAt || lead.leadCallDate);
  };

  // Enhanced filtering logic with carry-forward
  // const filteredLeads = React.useMemo(() => {
  //   if (!leadsData.length) return [];

  //   const today = new Date();
  //   let targetDate = today;

  //   // Determine target date based on filter
  //   switch (dateFilter) {
  //     case "yesterday":
  //       targetDate = new Date(today);
  //       targetDate.setDate(targetDate.getDate() - 1);
  //       break;
  //     case "tomorrow":
  //       targetDate = new Date(today);
  //       targetDate.setDate(targetDate.getDate() + 1);
  //       break;
  //     case "custom":
  //       if (selectedDate) {
  //         targetDate = new Date(selectedDate);
  //       }
  //       break;
  //     case "all":
  //       // For "all" filter, show all leads without date filtering
  //       return leadsData.filter((lead) => {
  //         if (statusFilter !== "all") {
  //           const filterStatus = filterStatusMap[statusFilter];
  //           return filterStatus ? lead.status === filterStatus : true;
  //         }
  //         return true;
  //       });
  //     case "today":
  //     default:
  //       targetDate = today;
  //   }

  //   const isToday = isSameDay(targetDate, today);

  //   const filtered = leadsData.filter((lead) => {
  //     // Skip dead leads in normal views
  //     if (lead.status === "dead" && statusFilter !== "dead") {
  //       return false;
  //     }

  //     // Skip closed leads in normal views
  //     if (lead.status === "closed" && statusFilter !== "closed") {
  //       return false;
  //     }

  //     // Date filtering
  //     const shouldShowLead = shouldLeadBeShownOnDate(lead, targetDate, isToday);
  //     if (!shouldShowLead) {
  //       return false;
  //     }

  //     // Status filtering
  //     if (statusFilter !== "all") {
  //       const filterStatus = filterStatusMap[statusFilter];
  //       if (filterStatus && lead.status !== filterStatus) {
  //         return false;
  //       }
  //     }

  //     return true;
  //   });

  //   // Sort by lead call date and time (most recent first)
  //   return filtered.sort((a, b) => {
  //     if (!a.leadCallDate && !b.leadCallDate) return 0;
  //     if (!a.leadCallDate) return 1;
  //     if (!b.leadCallDate) return -1;

  //     const timeA = new Date(a.leadCallDate).getTime();
  //     const timeB = new Date(b.leadCallDate).getTime();

  //     return timeB - timeA;
  //   });
  // }, [leadsData, dateFilter, selectedDate, statusFilter]);




  // const filteredLeads = React.useMemo(() => {
  //   if (!leadsData.length) return [];

  //   const today = new Date();
  //   let targetDate = today;

  //   // Determine target date based on filter
  //   switch (dateFilter) {
  //     case "yesterday":
  //       targetDate = new Date(today);
  //       targetDate.setDate(targetDate.getDate() - 1);
  //       break;
  //     case "tomorrow":
  //       targetDate = new Date(today);
  //       targetDate.setDate(targetDate.getDate() + 1);
  //       break;
  //     case "custom":
  //       if (selectedDate) {
  //         targetDate = new Date(selectedDate);
  //       }
  //       break;
  //     case "all":
  //       return leadsData.filter((lead) => {
  //         if (statusFilter !== "all") {
  //           const filterStatus = filterStatusMap[statusFilter];
  //           return filterStatus ? lead.status === filterStatus : true;
  //         }
  //         return true;
  //       });
  //     case "today":
  //     default:
  //       targetDate = today;
  //   }

  //   const filtered = leadsData.filter((lead) => {
  //     // Skip terminal leads in normal views
  //     const terminalStatuses = ["dead", "closed", "fully_paid"];
  //     if (
  //       terminalStatuses.includes(lead.status) &&
  //       statusFilter !== lead.status
  //     ) {
  //       return false;
  //     }

  //     // Date filtering with carry-forward logic
  //     const shouldShowLead = shouldLeadBeShownOnDate(
  //       lead,
  //       targetDate,
  //       dateFilter
  //     );
  //     if (!shouldShowLead) {
  //       return false;
  //     }

  //     // Status filtering
  //     if (statusFilter !== "all") {
  //       const filterStatus = filterStatusMap[statusFilter];
  //       if (filterStatus && lead.status !== filterStatus) {
  //         return false;
  //       }
  //     }

  //     return true;
  //   });

  //   // Sort by lead call date and time (most recent first)
  //   return filtered.sort((a, b) => {
  //     if (!a.leadCallDate && !b.leadCallDate) return 0;
  //     if (!a.leadCallDate) return 1;
  //     if (!b.leadCallDate) return -1;

  //     const timeA = new Date(a.leadCallDate).getTime();
  //     const timeB = new Date(b.leadCallDate).getTime();

  //     return timeB - timeA;
  //   });
  // }, [leadsData, dateFilter, selectedDate, statusFilter]);
  // 🚨 UNIFIED ROBUST FILTERING HELPER
  const isLeadMatchingStatus = (lead, filter) => {
    if (filter === "all") return true;

    const filterStatus = filterStatusMap[filter];

    // Collect all unique status values from the lead's various fields
    const leadStatuses = new Set([
      lead.status,
      lead.classificationStatus,
      lead.schedulingStatus,
      lead.quotationStatus,
      lead.paymentStatus,
      lead.leadStatus,
      // Also check terminal status flags
      lead.terminalStatus?.isTerminal ? lead.terminalStatus.terminalStatus : null,
      lead.closed?.isClosed ? 'closed' : null
    ].filter(s => s && s !== 'none'));

    // Direct match against mapped filter status
    let isMatch = leadStatuses.has(filterStatus);

    // Special matching for legacy/alternative naming conventions
    if (!isMatch) {
      if (filter === 'payment_overdue') {
        isMatch = leadStatuses.has('overdue') || leadStatuses.has('payment_overdue');
      } else if (filter === 'closed' || filter === 'dead') {
        isMatch = leadStatuses.has(filter);
      } else if (filter === 'follow_up') {
        isMatch = leadStatuses.has('follow-up') || leadStatuses.has('followup');
      } else if (filter === 'quotation_rejected') {
        isMatch = leadStatuses.has('rejected') || leadStatuses.has('quotation_rejected');
      }
    }

    return isMatch;
  };

  // Helper function to get when lead was marked dead/closed
  const filteredLeads = React.useMemo(() => {
    if (!leadsData.length) return [];

    console.log('=== FILTERING LEADS ===');
    console.log('Status filter:', statusFilter);
    console.log('Date filter:', dateFilter);

    const today = new Date();
    let targetDate = today;

    // Determine target date based on filter
    switch (dateFilter) {
      case "yesterday":
        targetDate = new Date(today);
        targetDate.setDate(targetDate.getDate() - 1);
        break;
      case "tomorrow":
        targetDate = new Date(today);
        targetDate.setDate(targetDate.getDate() + 1);
        break;
      case "custom":
        if (selectedDate) {
          // 🚨 FIX: Parse as local date to avoid timezone shifts
          const [y, m, d] = selectedDate.split('-').map(Number);
          targetDate = new Date(y, m - 1, d);
        }
        break;
      case "all":
        // For "all" filter, show all leads matching status
        return leadsData.filter((lead) => isLeadMatchingStatus(lead, statusFilter));
      case "today":
      default:
        targetDate = today;
    }

    // For date-specific filters
    const filtered = leadsData.filter((lead) => {
      // Use effective status for date visibility logic without changing the logic itself
      // This ensures terminal statuses (closed, dead) are hidden correctly except on their terminal date
      const effectiveStatus = (lead.classificationStatus && lead.classificationStatus !== 'none') ? lead.classificationStatus : lead.status;
      const proxyLead = { ...lead, status: effectiveStatus };

      const shouldShowLead = shouldLeadBeShownOnDate(proxyLead, targetDate, dateFilter);
      if (!shouldShowLead) {
        return false;
      }

      // Status filtering - USE UNIFIED HELPER
      if (!isLeadMatchingStatus(lead, statusFilter)) {
        return false;
      }

      return true;
    });

    console.log('Final filtered leads:', filtered.length);
    return filtered.sort((a, b) => {
      if (!a.leadCallDate && !b.leadCallDate) return 0;
      if (!a.leadCallDate) return 1;
      if (!b.leadCallDate) return -1;
      return new Date(b.leadCallDate).getTime() - new Date(a.leadCallDate).getTime();
    });
  }, [leadsData, dateFilter, selectedDate, statusFilter]);

  // Show alert function
  const showAlert = (severity, message) => {
    setAlert({
      open: true,
      severity,
      message,
    });
  };

  // Helper functions for date/time formatting

  const formatTime = (dateValue, isDateOnly) => {
    if (!dateValue) return "";

    // 🚨 If it's marked as date-only, don't show time
    if (isDateOnly) {
      return "";
    }

    // If it's a string date (YYYY-MM-DD), don't show time
    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      return "";
    }

    // Otherwise, it's a Date object - check if time is meaningful
    const date = new Date(dateValue);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Don't show time if it's midnight (00:00) or 5:30 AM (from UTC conversion)
    if ((hours === 0 && minutes === 0) || (hours === 5 && minutes === 30)) {
      return "";
    }

    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatPlatform = (platform) => {
    if (!platform) return "";

    const platformMap = {
      google_meet: "Google Meet",
      zoom: "Zoom",
      microsoft_teams: "Microsoft Teams",
      phone_call: "Phone Call",
      offline: "Offline Meeting",
      skype: "Skype",
      webex: "Webex",
      other: "Other Platform",
    };

    return (
      platformMap[platform] ||
      platform.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
    );
  };

  const handleCloseAlert = () => {
    setAlert({ open: false, severity: "success", message: "" });
  };

  const handleOpenAddLead = () => setOpenAddLeadPop(true);
  const handleCloseAddLead = () => setOpenAddLeadPop(false);

  const handleOpenAssignLead = () => setAssignLeadOpen(true);
  const handleCloseAssignLead = () => setAssignLeadOpen(false);

  const handleOpenUpdateDialog = (lead) => {
    setSelectedLead(lead);

    // Extract existing meeting data if available
    const existingMeeting = lead.meeting || {};

    // Get existing date/time
    const existingDateTime = lead.meeting?.dateTime ||
      lead.rescheduledDate ||
      lead.meetingScheduledDate ||
      lead.leadCallDate;

    // Format for input and check if time exists
    let formattedDateTime = "";
    let hasTime = false;

    if (existingDateTime) {
      const date = new Date(existingDateTime);
      const dateStr = date.toISOString().split('T')[0];
      const timeStr = date.toTimeString().split(' ')[0].substring(0, 5); // HH:mm

      // Check if time is meaningful (not midnight or 5:30 AM)
      const hours = date.getHours();
      const minutes = date.getMinutes();
      hasTime = !(hours === 0 && minutes === 0) && !(hours === 5 && minutes === 30);

      formattedDateTime = hasTime ? `${dateStr}T${timeStr}` : dateStr;
    }

    // 🚨 PRE-POPULATE QUOTATION DATA FOR REVISIONS
    let preFilledQuotationData = {
      services: [],
      discount: 0,
      validUntil: "",
      templateUsed: "",
    };

    if (lead.quotations && lead.quotations.length > 0) {
      const latestQuotation = lead.quotations[lead.quotations.length - 1];
      console.log("📋 Found existing quotation for pre-filling:", latestQuotation);

      preFilledQuotationData = {
        services: (latestQuotation.services || []).map((service, index) => ({
          serviceType: service.serviceType || "CustomService",
          serviceName: service.serviceName || `Service ${index + 1}`,
          fields: (service.fields || []).map(field => ({
            name: field.name,
            label: field.label || field.name,
            value: field.value || "",
            type: field.type || "text",
            priceField: field.priceField || false,
            derived: field.derived || false,
            readOnly: field.readOnly || false,
          })),
          calculatedTotal: service.calculatedTotal || 0,
          _id: service._id || `service-${Date.now()}-${index}`,
        })),
        discount: latestQuotation.discount || 0,
        validUntil: latestQuotation.validUntil
          ? new Date(latestQuotation.validUntil).toISOString().split('T')[0]
          : "",
        templateUsed: latestQuotation.templateUsed || "",
      };
    }

    // Initialize form data
    setFormData({
      callStatus: lead.callStatus || "",
      leadStatus: lead.classificationStatus || lead.leadStatus || "", // 🚨 USE classificationStatus
      schedulingAction: lead.schedulingStatus || "", // 🚨 USE schedulingStatus
      dateTime: formattedDateTime || "",
      meetingPlatform: existingMeeting.platform || "",
      meetingLink: existingMeeting.link || "",
      location: existingMeeting.location || "",
      remarks: "",
      meetingRemarks: existingMeeting.remarks || "",
      remarksOnStatusChange: "",
      quotationTemplate: preFilledQuotationData.templateUsed || "",
      meetingAction: "",
      quotationStatus: "",
      selectedServices: [],
      quotationData: preFilledQuotationData,
      revisionRemarks: "",
      includeTime: hasTime || false, // Initialize based on existing data
    });
    setOpenUpdateDialog(true);
  };

  const handleCloseUpdateDialog = () => {
    setOpenUpdateDialog(false);
    setSelectedLead(null);
    setFormData({
      callStatus: "",
      leadStatus: "",
      dateTime: "",
      meetingPlatform: "",
      meetingLink: "",
      location: "",
      remarks: "",
      meetingRemarks: "",
      remarksOnStatusChange: "",
      quotationTemplate: "",
      meetingAction: "",
      selectedServices: [],
      quotationData: {
        services: [],
        discount: 0,
        validUntil: "",
        templateUsed: "",
      },
    });
  };

  // Get dynamic lead status options based on call status
  const getLeadStatusOptions = (callStatus) => {
    switch (callStatus) {
      case "received":
        return [
          { value: "hot", label: "Hot Lead" },
          { value: "warm", label: "Warm Lead" },
          { value: "dead", label: "Dead Lead" },
          { value: "send_quotation", label: "Make Quotation" },
          { value: "rescheduled", label: "Reschedule Call" },
          { value: "meeting_scheduled", label: "Schedule Meeting" },
          { value: "closed", label: "Deal Closed" },
        ];

      case "call_not_received":
      case "switch_off":
        return [
          { value: "rescheduled", label: "Reschedule Call" },
          { value: "meeting_scheduled", label: "Schedule Meeting" },
        ];

      case "wrong_number":
        return [{ value: "dead", label: "Mark as Dead (Wrong Number)" }];

      default:
        return [];
    }
  };

  // const handleCallStatusChange = (e) => {
  //   const { name, value } = e.target;

  //   // Reset lead status when call status changes
  //   if (name === "callStatus") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //       leadStatus: "", // Reset lead status
  //       // Reset scheduling fields
  //       dateTime: "",
  //       meetingPlatform: "",
  //       meetingLink: "",
  //       location: "",
  //       meetingRemarks: "",
  //       meetingAction: "",
  //     }));
  //   } else {
  //     handleChange(e);
  //   }
  // };
  const handleCallStatusChange = (e) => {
    const { name, value } = e.target;

    if (name === "callStatus") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        leadStatus: "", // Reset lead status
        schedulingAction: "", // Reset scheduling action
        // Reset scheduling fields
        dateTime: "",
        meetingPlatform: "",
        meetingLink: "",
        location: "",
        meetingRemarks: "",
      }));
    } else {
      handleChange(e);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle nested quotationData fields
    if (name.startsWith("quotationData.")) {
      const fieldName = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        quotationData: {
          ...prev.quotationData,
          [fieldName]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Auto-calculate derived fields for quotation
    if (
      formData.quotationTemplate &&
      derivedFieldsMap[formData.quotationTemplate]
    ) {
      const derivedFields = derivedFieldsMap[formData.quotationTemplate];
      Object.entries(derivedFields).forEach(([derivedName, calcFn]) => {
        // This might need adjustment based on your new structure
      });
    }

    // 🚨 PRE-FILL QUOTATION DATA WHEN STATUS CHANGES TO send_quotation
    if (name === "leadStatus" && value === "send_quotation" && formData.quotationData.services.length === 0) {
      if (selectedLead && selectedLead.quotations && selectedLead.quotations.length > 0) {
        const latestQuotation = selectedLead.quotations[selectedLead.quotations.length - 1];
        console.log("📋 Status changed to send_quotation. Pre-filling from latest quotation.");

        const preFilledQuotationData = {
          services: (latestQuotation.services || []).map((service, index) => ({
            serviceType: service.serviceType || "CustomService",
            serviceName: service.serviceName || `Service ${index + 1}`,
            fields: (service.fields || []).map(field => ({
              name: field.name,
              label: field.label || field.name,
              value: field.value || "",
              type: field.type || "text",
              priceField: field.priceField || false,
              derived: field.derived || false,
              readOnly: field.readOnly || false,
            })),
            calculatedTotal: service.calculatedTotal || 0,
            _id: service._id || `service-${Date.now()}-${index}`,
          })),
          discount: latestQuotation.discount || 0,
          validUntil: latestQuotation.validUntil
            ? new Date(latestQuotation.validUntil).toISOString().split('T')[0]
            : "",
          templateUsed: latestQuotation.templateUsed || "",
        };

        setFormData(prev => ({
          ...prev,
          quotationData: preFilledQuotationData,
          quotationTemplate: preFilledQuotationData.templateUsed || prev.quotationTemplate
        }));
      }
    }
  };




  // Fixed PDF Generation function

  // const handleUpdateLeadStatus = async () => {
  //   try {
  //     if (!selectedLead) return;

  //     setLoading(true);

  //     console.log('=== STARTING QUOTATION CREATION ===');
  //     console.log('Selected Lead:', selectedLead);
  //     console.log('Form Data:', formData);

  //     // Determine final status
  //     let finalLeadStatus = formData.leadStatus;
  //     if (formData.schedulingAction) {
  //       finalLeadStatus = formData.schedulingAction;
  //     }

  //     const normalizedLeadStatus =
  //       finalLeadStatus === "send_quotation"
  //         ? "quotation_shared"
  //         : finalLeadStatus;

  //     console.log('Normalized Lead Status:', normalizedLeadStatus);

  //     // 🚨 CRITICAL: Handle date without time
  //     let leadCallDateValue = "";
  //     let dateTimeValue = "";

  //     if (formData.dateTime) {
  //       const dateOnly = formData.dateTime.includes('T') 
  //         ? formData.dateTime.split('T')[0]
  //         : formData.dateTime;

  //       if (formData.includeTime && formData.dateTime.includes('T')) {
  //         dateTimeValue = convertToISOString(formData.dateTime);
  //         leadCallDateValue = convertToISOString(formData.dateTime);
  //       } else {
  //         dateTimeValue = dateOnly;
  //         leadCallDateValue = dateOnly;
  //       }
  //     }

  //     // Build payload
  //     const payload = {
  //       leadId: selectedLead._id,
  //       userId: UID,
  //       callStatus: formData.callStatus,
  //       leadStatus: normalizedLeadStatus,
  //       schedulingAction: formData.schedulingAction,
  //       meetingPlatform: formData.meetingPlatform,
  //       meetingLink: formData.meetingLink,
  //       location: formData.location,
  //       remarks: formData.remarks,
  //       meetingRemarks: formData.meetingRemarks,
  //       companyId: selectedLead.companyId || CID,
  //       priority: formData.priority,
  //       isStatusUpdate: true,
  //       dateTime: dateTimeValue,
  //       leadCallDate: leadCallDateValue,
  //       includeTime: formData.includeTime || false,
  //       isDateOnly: !formData.includeTime || !formData.dateTime.includes('T')
  //     };

  //     // Handle quotation data if sending quotation
  //     if (formData.leadStatus === "send_quotation") {
  //       payload.quotationData = {
  //         services: formData.quotationData.services,
  //         discount: parseFloat(formData.quotationData.discount) || 0,
  //         validUntil: formData.quotationData.validUntil,
  //         templateUsed: formData.quotationTemplate || "CustomService",
  //       };

  //       console.log('Quotation Data to send:', payload.quotationData);
  //       console.log('Number of services:', formData.quotationData.services.length);

  //       // Validate services
  //       formData.quotationData.services.forEach((service, index) => {
  //         console.log(`Service ${index + 1}:`, {
  //           serviceName: service.serviceName,
  //           serviceType: service.serviceType,
  //           fields: service.fields,
  //           calculatedTotal: service.calculatedTotal
  //         });
  //       });
  //     }

  //     console.log('Full Payload:', JSON.stringify(payload, null, 2));

  //     // Update lead status
  //     const updateRes = await fetch(`${url}/api/leads/update-lead-status`, {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     console.log('Response Status:', updateRes.status);

  //     const updateData = await updateRes.json();
  //     console.log('Response Data:', updateData);

  //     if (!updateRes.ok) {
  //       throw new Error(updateData.message || "Failed to update lead status");
  //     }

  //     showAlert("success", "Lead status updated successfully");

  //     // Refresh leads
  //     await fetchLeads();
  //     handleCloseUpdateDialog();

  //   } catch (error) {
  //     console.error('❌ Error updating lead:', error);
  //     console.error('Error details:', error.stack);
  //     showAlert("error", error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleUpdateLeadStatus = async () => {
    try {
      if (!selectedLead) {
        console.error("❌ No lead selected");
        showAlert("error", "No lead selected for update");
        return;
      }

      setLoading(true);

      // 🚨 CRITICAL DEBUGGING - Log everything
      console.log("🚀 ========== handleUpdateLeadStatus STARTED ==========");
      console.log("📋 Selected Lead:", {
        id: selectedLead._id,
        name: selectedLead.clientName,
        currentStatus: selectedLead.status,
        currentLeadCallDate: selectedLead.leadCallDate
      });

      console.log("📝 Form Data:", JSON.stringify(formData, null, 2));

      // Determine final status
      // 🚨 REMOVED OVERWRITE LOGIC: Let leadStatus and schedulingAction remain independent
      let finalLeadStatus = formData.leadStatus;

      let classificationStatus = "";
      let quotationStatus = formData.quotationStatus || "";

      // 🚨 Correct mapping logic
      if (classificationStatuses.includes(formData.leadStatus)) {
        classificationStatus = formData.leadStatus;
      } else if (quotationStatuses.includes(formData.leadStatus)) {
        quotationStatus = formData.leadStatus === "send_quotation" ? "quotation_shared" : formData.leadStatus;
      }

      const normalizedLeadStatus =
        formData.leadStatus === "send_quotation"
          ? "quotation_shared"
          : formData.leadStatus;

      console.log("🔄 Status Analysis:", {
        formLeadStatus: formData.leadStatus,
        schedulingAction: formData.schedulingAction,
        finalLeadStatus: finalLeadStatus,
        normalizedLeadStatus: normalizedLeadStatus,
        currentLeadStatus: selectedLead.status
      });

      // 🚨 FIX: Handle date/time properly
      let leadCallDateValue = "";
      let dateTimeValue = "";

      if (formData.dateTime) {
        console.log("📅 Form dateTime value:", formData.dateTime);

        if (formData.includeTime && formData.dateTime.includes('T')) {
          // Has time
          dateTimeValue = convertToISOString(formData.dateTime);
          leadCallDateValue = convertToISOString(formData.dateTime);
          console.log("⏰ Includes time - ISO:", dateTimeValue);
        } else {
          // Date only
          const dateOnly = formData.dateTime.includes('T')
            ? formData.dateTime.split('T')[0]
            : formData.dateTime;
          dateTimeValue = dateOnly;
          leadCallDateValue = dateOnly;
          console.log("📆 Date only:", dateOnly);
        }
      }

      // 🚨 CRITICAL: Ensure includeTime and isDateOnly are ALWAYS defined
      const includeTime = formData.includeTime || false;
      const isDateOnly = !includeTime;

      // Build payload with ALL required fields
      const payload = {
        leadId: selectedLead._id,
        userId: UID,
        callStatus: formData.callStatus || "received",
        // Multi-status fields
        classificationStatus: classificationStatus,
        schedulingStatus: formData.schedulingAction || "",
        quotationStatus: quotationStatus,
        // Legacy fields for backward compatibility
        leadStatus: normalizedLeadStatus,
        schedulingAction: formData.schedulingAction || "",

        meetingPlatform: formData.meetingPlatform || "",
        meetingLink: formData.meetingLink || "",
        location: formData.location || "",
        remarks: formData.remarks || "",
        meetingRemarks: formData.meetingRemarks || "",
        companyId: selectedLead.companyId || CID,
        priority: formData.priority || "medium",
        isStatusUpdate: true,
        dateTime: dateTimeValue,
        leadCallDate: leadCallDateValue,
        includeTime: includeTime,
        isDateOnly: isDateOnly,
        // Payment info if applicable
        paymentAmount: formData.paymentAmount,
        paymentMethod: formData.paymentMethod
      };

      // Handle quotation data if sending quotation
      if ((formData.leadStatus === "send_quotation" || formData.quotationStatus === "send_quotation") && formData.quotationData) {
        payload.quotationData = {
          services: formData.quotationData.services,
          discount: parseFloat(formData.quotationData.discount) || 0,
          validUntil: formData.quotationData.validUntil,
          templateUsed: formData.quotationTemplate || "CustomService",
        };

        console.log("📋 Quotation data included:", {
          servicesCount: formData.quotationData.services.length,
          discount: formData.quotationData.discount,
          validUntil: formData.quotationData.validUntil
        });
      }

      console.log("📤 Full Payload being sent:", JSON.stringify(payload, null, 2));
      console.log("🌐 Sending to URL:", `${url}/api/leads/update-lead-status`);

      // Update lead status
      const updateRes = await fetch(`${url}/api/leads/update-lead-status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          // Add authorization if needed
          "Authorization": `Bearer ${localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify(payload),
      });

      console.log("📡 API Response Status:", updateRes.status);
      console.log("📡 API Response Headers:", updateRes.headers);

      if (!updateRes.ok) {
        const errorText = await updateRes.text();
        console.error("❌ API Error Response:", errorText);
        throw new Error(`API Error (${updateRes.status}): ${errorText}`);
      }

      const updateData = await updateRes.json();
      console.log("✅ API Success Response:", updateData);

      if (updateData.message) {
        showAlert("success", updateData.message);
      } else {
        showAlert("success", "Lead status updated successfully");
      }

      // Refresh leads
      await fetchLeads();
      handleCloseUpdateDialog();

    } catch (error) {
      console.error('❌ ERROR in handleUpdateLeadStatus:', error);
      console.error('Error stack:', error.stack);
      showAlert("error", `Update failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const handlePreviewPDF = async (service) => {
    try {
      if (!selectedLead) {
        showAlert("error", "No lead selected.");
        return;
      }

      // Use the service type as template name
      const templateName = service.serviceType || "CustomService";

      // Prepare service-specific data for the template
      const serviceValues = {};

      // Add all service field values
      service.fields.forEach((field) => {
        serviceValues[field.name] = field.value || "";
      });

      // Add calculated totals
      serviceValues.serviceTotal = service.calculatedTotal || 0;
      serviceValues.serviceName = service.serviceName;

      // Add lead information
      serviceValues.clientName = selectedLead.clientName;
      serviceValues.clientEmail = selectedLead.email;
      serviceValues.phone = selectedLead.contactNo;
      serviceValues.date = new Date().toLocaleDateString();

      // Add discount and final amount if available
      if (formData.quotationData.discount) {
        serviceValues.discount = formData.quotationData.discount;
        serviceValues.finalAmount =
          service.calculatedTotal -
          parseFloat(formData.quotationData.discount || 0);
      } else {
        serviceValues.finalAmount = service.calculatedTotal;
      }

      // Add validity if available
      if (formData.quotationData.validUntil) {
        serviceValues.validUntil = formData.quotationData.validUntil;
      }

      // Add service context for multiple services
      const serviceIndex = formData.quotationData.services.findIndex(
        (s) => s._id === service._id
      );
      serviceValues.serviceIndex = serviceIndex + 1;
      serviceValues.totalServices = formData.quotationData.services.length;

      const quotationPayload = {
        leadId: selectedLead._id,
        userId: UID,
        templateName: templateName,
        values: serviceValues,
      };

      console.log("📄 Generating PDF preview for service:", {
        templateName,
        serviceName: service.serviceName,
        serviceIndex: serviceIndex + 1,
        totalServices: formData.quotationData.services.length,
      });

      const res = await fetch(`${url}/api/templates/preview`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(quotationPayload),
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Failed to generate preview");
      }

      const blob = await res.blob();

      if (blob.size === 0) {
        throw new Error("Generated PDF is empty");
      }

      const pdfUrl = window.URL.createObjectURL(blob);
      const newWindow = window.open(pdfUrl, "_blank");

      if (!newWindow) {
        showAlert(
          "warning",
          "Popup blocked! Please allow popups for this site to view the PDF."
        );
      }
    } catch (err) {
      console.error("❌ PDF Preview error:", err);
      showAlert("error", `Error generating preview: ${err.message}`);
    }
  };

  const handlePreviewAllPDF = async () => {
    try {
      if (!selectedLead) {
        showAlert("error", "No lead selected.");
        return;
      }

      if (formData.quotationData.services.length === 0) {
        showAlert("error", "No services added to quotation.");
        return;
      }

      const servicesToPreview = formData.quotationData.services.map((service, index) => {
        const serviceValues = {};
        service.fields.forEach((field) => {
          serviceValues[field.name] = field.value || "";
        });
        serviceValues.serviceTotal = service.calculatedTotal || 0;
        serviceValues.serviceName = service.serviceName;
        serviceValues.serviceIndex = index + 1;
        serviceValues.totalServices = formData.quotationData.services.length;

        return {
          templateName: service.serviceType || "CustomService",
          values: serviceValues
        };
      });

      const payload = {
        leadId: selectedLead._id,
        userId: UID,
        services: servicesToPreview,
        values: {
          discount: formData.quotationData.discount || 0,
          validUntil: formData.quotationData.validUntil || "",
          date: new Date().toLocaleDateString()
        }
      };

      console.log("📄 Generating combined PDF preview for all services");

      const res = await fetch(`${url}/api/templates/preview-combined`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Failed to generate combined preview");
      }

      const blob = await res.blob();
      const pdfUrl = window.URL.createObjectURL(blob);
      const newWindow = window.open(pdfUrl, "_blank");

      if (!newWindow) {
        showAlert("warning", "Popup blocked! Please allow popups to view the PDF.");
      }
    } catch (err) {
      console.error("❌ Combined PDF Preview error:", err);
      showAlert("error", `Error generating combined preview: ${err.message}`);
    }
  };

  const handleOpenViewRemarks = async () => {
    setViewRemarksOpen(true);
  };

  const handleCloseViewRemarks = () => {
    setViewRemarksOpen(false);
  };

  const handleDateFilterChange = (filter) => {
    console.log('Changing date filter to:', filter);
    setDateFilter(filter);

    // Only update URL if NOT coming from dashboard navigation
    const params = new URLSearchParams(window.location.search);
    const currentStatus = params.get('status');

    // If we have a status filter from dashboard, preserve it
    if (currentStatus) {
      params.set('status', currentStatus);
    }

    params.set('dateFilter', filter);

    // Update URL
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
  };



  const handleStatusFilterChange = (status) => {
    console.log('Changing status filter to:', status);
    setStatusFilter(status);

    const params = new URLSearchParams(window.location.search);
    let currentDateFilter = params.get('dateFilter') || 'all';

    // 🚨 AUTO-SWITCH to "all" for terminal and special statuses
    // This prevents leads from being hidden because their terminal/event date doesn't match "Today"
    if (['closed', 'dead', 'overdue', 'payment_overdue'].includes(status)) {
      currentDateFilter = 'all';
      setDateFilter('all');
    }

    if (status !== 'all') {
      params.set('status', status);
    } else {
      params.delete('status');
    }

    params.set('dateFilter', currentDateFilter);

    // Update URL
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
  };

  const handleCompanyFilterChange = (company) => {
    setCompanyFilter(company);
  };

  // Filter popover handlers
  const handleOpenFilterPopover = (event) => {
    setTempFilters({
      status: statusFilter,
      company: companyFilter,
    });
    setFilterAnchorEl(event.currentTarget);
  };

  // Replace the handleQuotationStatusChange function with this updated version
  // const handleQuotationStatusChange = async (value, quotation) => {
  //   try {
  //     setLoading(true);

  //     if (value !== "send_quotation") {
  //       // For status updates (approved, rejected, etc.)
  //       setFormData((prev) => ({
  //         ...prev,
  //         quotationStatus: value,
  //         leadStatus: value,
  //         callStatus: "received",
  //         remarks: `Quotation status updated to ${value}`,
  //       }));

  //       showAlert(
  //         "info",
  //         `Quotation status will be updated to ${value}. Click 'Update Status' to confirm.`
  //       );
  //     } else {
  //       // Handle revised quotation creation
  //       let existingQuotation = quotation;

  //       // If no quotation provided, try to get from selectedLead
  //       if (!existingQuotation && selectedLead) {
  //         if (selectedLead.quotations && selectedLead.quotations.length > 0) {
  //           // Get the latest quotation
  //           existingQuotation =
  //             selectedLead.quotations[selectedLead.quotations.length - 1];
  //           console.log(
  //             "📋 Found latest quotation from lead:",
  //             existingQuotation
  //           );
  //         } else if (selectedLead.activeQuotation) {
  //           // Try to find by activeQuotation ID
  //           existingQuotation = selectedLead.quotations?.find(
  //             (q) => q._id === selectedLead.activeQuotation
  //           );
  //           console.log("📋 Found active quotation:", existingQuotation);
  //         }
  //       }

  //       if (existingQuotation) {
  //         console.log(
  //           "📋 Loading existing quotation for revision:",
  //           existingQuotation
  //         );

  //         // Set the selected quotation for revision FIRST
  //         setSelectedQuotationForRevision(existingQuotation);

  //         // Transform the existing quotation data to match the form structure
  //         const updatedQuotationData = {
  //           services:
  //             existingQuotation.services?.map((service, index) => {
  //               // Ensure all required fields are present with proper defaults
  //               const serviceData = {
  //                 serviceType: service.serviceType || "CustomService",
  //                 serviceName: service.serviceName || `Service ${index + 1}`,
  //                 fields:
  //                   service.fields?.map((field) => ({
  //                     name: field.name,
  //                     label:
  //                       field.label ||
  //                       field.name
  //                         .replace(/([A-Z])/g, " $1")
  //                         .replace(/^./, (str) => str.toUpperCase()),
  //                     value: field.value || "",
  //                     type: field.type || "text",
  //                     priceField: field.priceField || false,
  //                     derived: field.derived || false,
  //                     readOnly: field.readOnly || false,
  //                   })) || [],
  //                 calculatedTotal: service.calculatedTotal || 0,
  //                 _id: service._id || `service-${Date.now()}-${index}`,
  //               };

  //               console.log(
  //                 `📦 Service ${index} loaded:`,
  //                 serviceData.serviceName
  //               );
  //               return serviceData;
  //             }) || [],
  //           discount: existingQuotation.discount || 0,
  //           validUntil: existingQuotation.validUntil
  //             ? new Date(existingQuotation.validUntil)
  //                 .toISOString()
  //                 .split("T")[0]
  //             : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  //                 .toISOString()
  //                 .split("T")[0],
  //           templateUsed: existingQuotation.templateUsed || "CustomService",
  //         };

  //         console.log(
  //           "✅ Updated quotation data loaded for form:",
  //           updatedQuotationData
  //         );

  //         setFormData((prev) => ({
  //           ...prev,
  //           quotationStatus: value,
  //           leadStatus: "send_quotation",
  //           callStatus: "received",
  //           quotationData: updatedQuotationData,
  //           revisionRemarks: "", // Initialize revision remarks
  //         }));

  //         showAlert(
  //           "success",
  //           "Existing quotation loaded for revision. You can now modify the services and amounts."
  //         );
  //       } else {
  //         // No existing quotation found
  //         console.log("❌ No existing quotation found for revision");
  //         setSelectedQuotationForRevision(null);

  //         // Start with empty services
  //         setFormData((prev) => ({
  //           ...prev,
  //           quotationStatus: value,
  //           leadStatus: "send_quotation",
  //           callStatus: "received",
  //           quotationData: {
  //             services: [],
  //             discount: 0,
  //             validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  //               .toISOString()
  //               .split("T")[0],
  //             templateUsed: "CustomService",
  //           },
  //           revisionRemarks: "",
  //         }));

  //         showAlert(
  //           "info",
  //           "No existing quotation found. Please add services to create a new quotation."
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.error("❌ Error updating quotation status:", error);
  //     showAlert("error", error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleQuotationStatusChange = async (value, quotation) => {
    try {
      setLoading(true);

      if (value !== "send_quotation") {
        // For status updates (approved, rejected, etc.)
        setFormData((prev) => ({
          ...prev,
          quotationStatus: value,
          // 🚨 DON'T automatically overwrite leadStatus if it's already set to a classification
          leadStatus: (prev.leadStatus === "hot" || prev.leadStatus === "warm" || prev.leadStatus === "dead")
            ? prev.leadStatus
            : value,
          callStatus: "received",
          remarks: prev.remarks,
        }));
      } else {
        // 🚨 CRITICAL FIX: Clear existing services when creating revised quotation
        let existingQuotation = quotation;

        // If no quotation provided, try to get from selectedLead
        if (!existingQuotation && selectedLead) {
          if (selectedLead.quotations && selectedLead.quotations.length > 0) {
            existingQuotation =
              selectedLead.quotations[selectedLead.quotations.length - 1];
          }
        }

        // 🚨 RESET form data first to avoid duplication
        const resetFormData = {
          quotationStatus: value,
          leadStatus: "send_quotation",
          callStatus: "received",
          remarks: formData.remarks, // 🆕 KEEP existing remarks
          quotationData: {
            services: [],
            discount: 0,
            validUntil: "",
            templateUsed: "CustomService",
          },
          revisionRemarks: "",
        };

        setFormData(resetFormData);

        // Now load the existing quotation data
        if (existingQuotation) {
          console.log(
            "📋 Loading existing quotation for revision:",
            existingQuotation
          );

          // Transform the existing quotation data
          const updatedQuotationData = {
            services:
              existingQuotation.services?.map((service, index) => {
                const serviceData = {
                  serviceType: service.serviceType || "CustomService",
                  serviceName: service.serviceName || `Service ${index + 1}`,
                  fields:
                    service.fields?.map((field) => ({
                      name: field.name,
                      label:
                        field.label ||
                        field.name
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase()),
                      value: field.value || "",
                      type: field.type || "text",
                      priceField: field.priceField || false,
                      derived: field.derived || false,
                      readOnly: field.readOnly || false,
                    })) || [],
                  calculatedTotal: service.calculatedTotal || 0,
                  _id: service._id || `service-${Date.now()}-${index}`,
                };
                return serviceData;
              }) || [],
            discount: existingQuotation.discount || 0,
            validUntil: existingQuotation.validUntil
              ? new Date(existingQuotation.validUntil)
                .toISOString()
                .split("T")[0]
              : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
                .toISOString()
                .split("T")[0],
            templateUsed: existingQuotation.templateUsed || "CustomService",
          };

          // 🚨 Update form data with the quotation data (replaces empty services)
          setFormData((prev) => ({
            ...prev,
            quotationData: updatedQuotationData,
          }));

          showAlert(
            "success",
            "Existing quotation loaded for revision. You can now modify the services and amounts."
          );
        } else {
          showAlert(
            "info",
            "No existing quotation found. Please add services to create a new quotation."
          );
        }
      }
    } catch (error) {
      console.error("❌ Error updating quotation status:", error);
      showAlert("error", error.message);
    } finally {
      setLoading(false);
    }
  };
  const getQuotationStatusOptions = (currentValue, quotation) => {
    const baseOptions = {
      quotation_shared: [
        { value: "negotiation", label: "Client Negotiating" },
        { value: "quotation_approved", label: "Client Approved" },
        { value: "quotation_rejected", label: "Client Rejected" },
        { value: "quotation_expired", label: "Quotation Expired" },
        { value: "send_quotation", label: "Create Revised Quotation" },
      ],
      quotation_revised: [
        { value: "negotiation", label: "Client Negotiating" },
        { value: "quotation_approved", label: "Client Approved" },
        { value: "quotation_rejected", label: "Client Rejected" },
        { value: "quotation_expired", label: "Quotation Expired" },
        { value: "send_quotation", label: "Create Another Revision" },
      ],
      negotiation: [
        { value: "quotation_approved", label: "Client Approved" },
        { value: "quotation_rejected", label: "Client Rejected" },
        { value: "quotation_expired", label: "Quotation Expired" },
        { value: "send_quotation", label: "Create Revised Quotation" },
      ],
      quotation_approved: [
        { value: "closed", label: "Deal Closed" },
        { value: "send_quotation", label: "Create Revised Quotation" },
      ],
      quotation_rejected: [
        { value: "send_quotation", label: "Create Revised Quotation" },
        { value: "dead", label: "Mark as Dead" },
      ],
      quotation_expired: [
        { value: "send_quotation", label: "Create Revised Quotation" },
        { value: "dead", label: "Mark as Dead" },
      ],
    };

    // Use statusDisplayMap for labels
    const statusLabels = {
      quotation_shared: "Quotation Shared",
      quotation_approved: "Quotation Approved",
      quotation_rejected: "Quotation Rejected",
      quotation_revised: "Quotation Revised",
      quotation_expired: "Quotation Expired",
      negotiation: "Client Negotiating",
      send_quotation: "Revise Quotation",
      closed: "Deal Closed",
      dead: "Mark as Dead"
    };

    let options = baseOptions[currentValue] || [
      { value: "negotiation", label: "Client Negotiating" },
      { value: "quotation_approved", label: "Client Approved" },
      { value: "quotation_rejected", label: "Client Rejected" },
      { value: "quotation_expired", label: "Quotation Expired" },
      { value: "send_quotation", label: "Create Revised Quotation" },
    ];

    // 🚨 FIX: Always ensure the current value is in the options list so it's visible in the Select box
    if (currentValue && !options.find(opt => opt.value === currentValue)) {
      options.unshift({
        value: currentValue,
        label: statusLabels[currentValue] || currentValue
      });
    }

    return options;
  };
  const handleCloseFilterPopover = () => {
    setFilterAnchorEl(null);
  };

  const handleApplyFilters = () => {
    setStatusFilter(tempFilters.status);
    setCompanyFilter(tempFilters.company);
    handleCloseFilterPopover();
  };

  const handleResetFilters = () => {
    setTempFilters({
      status: "all",
      company: "all",
    });
    setStatusFilter("all");
    setCompanyFilter("all");
    handleCloseFilterPopover();
  };

  // Clear all filters
  const handleClearFilters = () => {
    setDateFilter("all");
    setStatusFilter("all");
    setCompanyFilter("all");
    setSelectedDate("");

    // Clear URL parameters
    window.history.replaceState({}, '', window.location.pathname);
  };

  // Update the leadStats calculation
  const leadStats = {
    total: filteredLeads.length,
    hot: filteredLeads.filter((lead) => lead.classificationStatus === "hot" || (!lead.classificationStatus && lead.status === "hot")).length,
    warm: filteredLeads.filter((lead) => lead.classificationStatus === "warm" || (!lead.classificationStatus && lead.status === "warm")).length,
    closed: filteredLeads.filter((lead) => lead.classificationStatus === "closed" || (!lead.classificationStatus && lead.status === "closed")).length,
    dead: filteredLeads.filter((lead) => lead.classificationStatus === "dead" || (!lead.classificationStatus && lead.status === "dead")).length,
    meeting: filteredLeads.filter((lead) => lead.schedulingStatus === "meeting_scheduled" || (!lead.schedulingStatus && lead.status === "meeting_scheduled"))
      .length,
    follow_up: filteredLeads.filter((lead) => lead.classificationStatus === "follow-up" || (!lead.classificationStatus && lead.status === "follow-up"))
      .length,
    rescheduled: filteredLeads.filter((lead) => lead.schedulingStatus === "rescheduled" || (!lead.schedulingStatus && lead.status === "rescheduled"))
      .length,
    quotation_shared: filteredLeads.filter(
      (lead) => lead.quotationStatus === "quotation_shared" || (!lead.quotationStatus && lead.status === "quotation_shared")
    ).length,
    quotation_approved: filteredLeads.filter(
      (lead) => lead.quotationStatus === "quotation_approved" || (!lead.quotationStatus && lead.status === "quotation_approved")
    ).length,
    quotation_revised: filteredLeads.filter(
      (lead) => lead.quotationStatus === "quotation_revised" || (!lead.quotationStatus && lead.status === "quotation_revised")
    ).length,
    // 🆕 PAYMENT STATS
    token_paid: filteredLeads.filter(
      (lead) => lead.status === "token_paid"
    ).length,
    partially_paid: filteredLeads.filter(
      (lead) => lead.status === "partially_paid"
    ).length,
    fully_paid: filteredLeads.filter(
      (lead) => lead.status === "fully_paid"
    ).length,
    payment_overdue: filteredLeads.filter(
      (lead) => lead.status === "payment_overdue"
    ).length,
    payment_pending: filteredLeads.filter(
      (lead) => lead.paymentStatus === "pending"
    ).length,
    quotation_rejected: filteredLeads.filter(
      (lead) => lead.quotationStatus === "rejected" || (!lead.quotationStatus && lead.status === "rejected")
    ).length,
    negotiation: filteredLeads.filter((lead) => lead.quotationStatus === "negotiation" || (!lead.quotationStatus && lead.status === "negotiation"))
      .length,
  };

  const canAddLead = userRole === "admin" || userRole === "teamMember";
  const canAssignLead = userRole === "admin";
  const canUpdateLead = userRole === "admin" || userRole === "teamMember";

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          bgcolor: "background.default",
          color: "text.primary",
          p: 3,
          ml: -4,
          overflow: "hidden",
          mt: -6,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Fixed Header Section */}
        {/* Fixed Header Section */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            bgcolor: "background.default",
            pb: 2,
            borderBottom: `1px solid ${alpha(primaryColor, 0.1)}`,
            mb: 2,
          }}
        >
          {/* First Row - Filter, Active Filters and Add Lead Button (Keep Original) */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              gap: 2,
            }}
          >
            {/* Left Side - Filter Button and Active Filters */}
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}
            >
              {/* Filter Button */}
              <Button
                variant="contained"
                startIcon={<FilterList />}
                onClick={handleOpenFilterPopover}
                sx={{
                  bgcolor: "transparent",
                  boxShadow: "none",
                  border: "none",
                  color: primaryColor,
                  "&:hover": {
                    bgcolor: alpha(primaryColor, 0.08),
                    boxShadow: "none",
                    border: "none",
                  },
                  minWidth: "auto",
                  px: 2.3,
                  height: "38px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "15px",
                }}
              >
                FILTERS
              </Button>

              {/* Active Filters Chips - Inline with Filter button */}
              {(statusFilter !== "all" ||
                companyFilter !== "all" ||
                dateFilter !== "all") && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    {/* Date Filter Chip */}
                    {dateFilter !== "all" && (
                      <Chip
                        icon={
                          dateFilter === "custom" ? (
                            <Event />
                          ) : dateFilter === "today" ? (
                            <Today />
                          ) : dateFilter === "yesterday" ? (
                            <ArrowBack />
                          ) : dateFilter === "tomorrow" ? (
                            <ArrowForward />
                          ) : (
                            <ViewList />
                          )
                        }
                        label={
                          dateFilter === "custom"
                            ? `Custom: ${selectedDate}`
                            : dateFilter === "today"
                              ? "Today"
                              : dateFilter === "yesterday"
                                ? "Yesterday"
                                : dateFilter === "tomorrow"
                                  ? "Tomorrow"
                                  : "All Leads"
                        }
                        size="medium"
                        onDelete={() => {
                          handleDateFilterChange("all"); // This now updates URL too
                        }}
                        sx={{
                          color: "success.main",
                          fontWeight: 700,
                          height: "32px",
                        }}
                      />
                    )}

                    {statusFilter !== "all" && (
                      <Chip
                        label={`Status: ${getDisplayStatus(
                          filterStatusMap[statusFilter] || statusFilter
                        )}`}
                        size="medium"
                        onDelete={() => {
                          handleStatusFilterChange("all");
                        }}
                        sx={{
                          color: "success.main",
                          fontWeight: 700,
                          height: "32px",
                        }}
                      />
                    )}
                    {/* Company Filter Chip */}
                    {companyFilter !== "all" && userRole === "superAdmin" && (
                      <Chip
                        label={`Company: ${companies.find((c) => c._id === companyFilter)
                          ?.companyName ||
                          companies.find((c) => c._id === companyFilter)?.name ||
                          "Unknown"
                          }`}
                        size="medium"
                        onDelete={() => handleCompanyFilterChange("all")}
                        sx={{
                          color: "success.main",
                          fontWeight: 700,
                          height: "32px",
                        }}
                      />
                    )}

                    {/* Clear All Filters */}
                    <Button
                      size="small"
                      startIcon={<Clear />}
                      onClick={handleClearFilters}
                      sx={{
                        color: "error.main",
                        fontSize: "0.75rem",
                        fontWeight: 500,
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                        height: "32px",
                      }}
                    >
                      Clear All
                    </Button>
                  </Box>
                )}
            </Box>

            {/* Search Bar & Actions */}
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {/* Search Bar */}
              <TextField
                placeholder="Search leads..."
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  width: "250px",
                  "& .MuiInputBase-root": {
                    height: 36,
                    bgcolor: alpha(mode === "light" ? "#fff" : theme.palette.background.paper, 0.8),
                  },
                  "& .MuiInputBase-input": {
                    padding: "6px 8px",
                    fontSize: "0.875rem",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ fontSize: 18, color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setSearchQuery("")}
                        sx={{ p: 0.5 }}
                      >
                        <Clear sx={{ fontSize: 16 }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {canAddLead && (
                <>

                  {/* Add Lead Button */}
                  <Button
                    variant="contained"
                    startIcon={<Add />}
                    sx={{
                      bgcolor: "primary.main",
                      "&:hover": { bgcolor: alpha(primaryColor, 0.9) },
                      height: "36px",
                    }}
                    onClick={handleOpenAddLead}
                  >
                    Add Lead
                  </Button>

                  {/* Hidden File Input */}
                  <input
                    type="file"
                    accept=".csv"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />

                  {/* Import Leads Button */}
                  <Tooltip
                    title={
                      !file
                        ? "Select a CSV file to import"
                        : "Upload selected CSV"
                    }
                  >
                    <Button
                      variant="outlined"
                      startIcon={
                        !loading && (file ? <UploadFile /> : <FileUpload />)
                      }
                      sx={{
                        borderColor: primaryColor,
                        color: primaryColor,
                        "&:hover": {
                          bgcolor: alpha(primaryColor, 0.1),
                          borderColor: primaryColor,
                        },
                        height: "36px",
                        textTransform: "none",
                        fontWeight: 600,
                      }}
                      onClick={file ? handleUpload : handleOpenFile}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : file ? (
                        "Upload CSV"
                      ) : (
                        "Import Leads"
                      )}
                    </Button>
                  </Tooltip>

                  {/* Status Message */}
                  {message && (
                    <Alert
                      severity={message.includes("success") ? "success" : "info"}
                      sx={{ mt: 2 }}
                    >
                      {message}
                    </Alert>
                  )}
                </>
              )}
            </Box>
          </Box>

          {/* Second Row - Stats and Date Filters in SINGLE ROW */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
              flexWrap: "nowrap",
            }}
          >
            {/* Left Side - Lead Statistics */}
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <Chip
                label={`Total: ${leadStats.total}`}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
              <Chip
                label={`Hot: ${leadStats.hot}`}
                variant="filled"
                color="info"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
              <Chip
                label={`Warm: ${leadStats.warm}`}
                variant="filled"
                color="info"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
              <Chip
                label={`Follow Up: ${leadStats.follow_up}`}
                variant="filled"
                color="secondary"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
              <Chip
                label={`Meetings: ${leadStats.meeting}`}
                variant="filled"
                color="secondary"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
              <Chip
                label={`Rescheduled: ${leadStats.rescheduled}`}
                variant="filled"
                color="secondary"
                size="small"
                sx={{ fontWeight: "bold", height: "32px" }}
              />
            </Box>


            {/* Right Side - Date Filters */}
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              {[
                { value: "all", label: "All Leads", icon: <ViewList /> },
                { value: "yesterday", label: "Yesterday", icon: <ArrowBack /> },
                { value: "today", label: "Today", icon: <Today /> },
                {
                  value: "tomorrow",
                  label: "Tomorrow",
                  icon: <ArrowForward />,
                },
              ].map((filter) => (
                <Chip
                  key={filter.value}
                  icon={filter.icon}
                  label={filter.label}
                  variant={dateFilter === filter.value ? "filled" : "outlined"}
                  color={dateFilter === filter.value ? "primary" : "default"}
                  onClick={() => handleDateFilterChange(filter.value)}
                  size="small"
                  sx={{
                    height: "32px",
                    ...(dateFilter === filter.value && {
                      bgcolor: "primary.main",
                      "&:hover": { bgcolor: alpha(primaryColor, 0.9) },
                    }),
                  }}
                />
              ))}

              {/* Date Picker */}
              <TextField
                type="date"
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value);
                  setDateFilter("custom");
                }}
                sx={{
                  width: "130px",
                  "& .MuiInputBase-root": {
                    height: 32,
                  },
                  "& .MuiInputBase-input": {
                    padding: "6px 8px",
                    fontSize: "0.875rem",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>

        {/* Scrollable Content Area - UPDATED */}
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            "& ::-webkit-scrollbar": { display: "none" },
            "&": {
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            },
          }}
        >
          {/* Leads Table */}
          <Card
            sx={{
              bgcolor: "background.paper",
              border: `2px solid ${alpha(primaryColor, 0.2)}`,
              borderRadius: 2,
              boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: 0,
                flex: 1,
                display: "flex",
                flexDirection: "column",
                "&:last-child": { pb: 0 },
              }}
            >
              {loading ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py={4}
                  flex={1}
                >
                  <CircularProgress sx={{ color: "primary.main" }} />
                </Box>
              ) : filteredLeads.length === 0 ? (
                <Typography
                  variant="h6"
                  textAlign="center"
                  py={4}
                  color="text.secondary"
                  flex={1}
                >
                  No leads found matching your filters
                </Typography>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{
                    flex: 1,
                    overflow: "auto",
                    position: "relative",
                    borderRadius: 0,
                    boxShadow: "none",
                    "& ::-webkit-scrollbar": { display: "none" },
                    "&": {
                      "-ms-overflow-style": "none",
                      "scrollbar-width": "none",
                    },
                    "& .MuiTableHead-root": {
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      backgroundColor: "background.paper",
                    },
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {userRole === "superAdmin" && (
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              bgcolor: "background.paper",
                              borderBottom: `2px solid ${alpha(
                                primaryColor,
                                0.3
                              )}`,
                              position: "sticky",
                              top: 0,
                              zIndex: 11,
                            }}
                          >
                            Company
                          </TableCell>
                        )}
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Client Name
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Contact No
                        </TableCell>
                        {/* Email Field Removed as per requirement #2 */}
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Lead Source
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Service Interested
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Lead Call Date
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            bgcolor: "background.paper",
                            borderBottom: `2px solid ${alpha(
                              primaryColor,
                              0.3
                            )}`,
                            position: "sticky",
                            top: 0,
                            zIndex: 11,
                          }}
                        >
                          Actions
                        </TableCell>
                        {canAssignLead && (
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              bgcolor: "background.paper",
                              borderBottom: `2px solid ${alpha(
                                primaryColor,
                                0.3
                              )}`,
                              position: "sticky",
                              top: 0,
                              zIndex: 11,
                            }}
                          >
                            Assign
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredLeads.map((lead, index) => {
                        const isHighlighted = isLeadHighlighted(lead._id);

                        return (
                          <TableRow
                            key={lead._id}
                            sx={{
                              backgroundColor: getStatusColor(
                                lead.status,
                                lead.leadStatus,
                                lead
                              ),
                              "&:hover": {
                                backgroundColor: `${getStatusColor(
                                  lead.status,
                                  lead.leadStatus,
                                  lead
                                )}DD`,
                              },
                              borderBottom: `1px solid ${alpha(
                                primaryColor,
                                0.1
                              )}`,
                              // 🎯 CLEAN HIGHLIGHT EFFECT - No layout changes
                              ...(isHighlighted && {
                                // Inner border effect using box-shadow inset
                                boxShadow: `inset 0 0 0 2px ${theme.palette.warning.main}`,
                                animation: "borderPulse 2s ease-in-out 3",
                                "@keyframes borderPulse": {
                                  "0%, 100%": {
                                    boxShadow: `inset 0 0 0 2px ${theme.palette.warning.main}`,
                                  },
                                  "50%": {
                                    boxShadow: `inset 0 0 0 3px ${theme.palette.warning.dark}`,
                                  },
                                },
                              }),
                              // Remove extra space at bottom for last row
                              "&:last-child td": {
                                borderBottom: "none",
                              },
                            }}
                          >
                            {/* ALL TABLE CELLS REMAIN EXACTLY THE SAME */}
                            {userRole === "superAdmin" && (
                              <TableCell
                                sx={{
                                  borderRight: `1px solid ${alpha(
                                    primaryColor,
                                    0.1
                                  )}`,
                                }}
                              >
                                {lead.company?.companyName ||
                                  lead.company?.name ||
                                  "N/A"}
                              </TableCell>
                            )}
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                                padding: "8px !important",
                              }}
                            >
                              <Box
                                sx={{
                                  p: 1.5,
                                  borderRadius: 1.5,
                                  transition: "all 0.2s ease",
                                  minHeight: "50px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    width: "100%",
                                  }}
                                >
                                  <Box sx={{ flex: 1 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      {lead.clientName}
                                    </Typography>

                                    {userRole === "admin" &&
                                      lead.assignedTo &&
                                      lead.assignedTo._id !==
                                      lead.addedBy?._id && (
                                        <Box
                                          sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            backgroundColor: alpha(
                                              primaryColor,
                                              0.1
                                            ),
                                            color: primaryColor,
                                            borderRadius: "12px",
                                            padding: "4px 8px",
                                            marginTop: "4px",
                                            border: `1px solid ${alpha(
                                              primaryColor,
                                              0.2
                                            )}`,
                                            fontSize: "0.7rem",
                                            fontWeight: "bold",
                                            fontStyle: "italic",
                                          }}
                                        >
                                          <Person
                                            sx={{ fontSize: "12px", mr: 0.5 }}
                                          />
                                          {lead.assignedTo.name}
                                        </Box>
                                      )}
                                  </Box>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                              }}
                            >
                              {lead.contactNo}
                            </TableCell>
                            {/* Email Field Removed as per requirement #2 */}
                            <TableCell
                              sx={{
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                              }}
                            >
                              {Array.isArray(lead.leadSources) &&
                                lead.leadSources.length > 0 ? (
                                <Box>
                                  {lead.leadSources.map((source, index) => (
                                    <Box key={index} sx={{ mb: 1 }}>
                                      <Typography variant="body2">
                                        {source.source}
                                        {source.otherSource && (
                                          <> ({source.otherSource})</>
                                        )}
                                      </Typography>
                                      {source.details && (
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                        >
                                          {source.details}
                                        </Typography>
                                      )}
                                      {index < lead.leadSources.length - 1 && (
                                        <Divider sx={{ my: 0.5 }} />
                                      )}
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                // Fallback to legacy single source
                                <>
                                  {lead.leadSource?.source}
                                  {lead.leadSource?.otherSource && (
                                    <> ({lead.leadSource.otherSource})</>
                                  )}
                                  <br />
                                  <small
                                    style={{
                                      color: theme.palette.text.secondary,
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    {lead.leadSource?.details}
                                  </small>
                                </>
                              )}
                            </TableCell>

                            {/* Service Interested Column */}
                            <TableCell
                              sx={{
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                              }}
                            >
                              {Array.isArray(lead.serviceInterested) &&
                                lead.serviceInterested.length > 0 ? (
                                lead.serviceInterested.map((service, index) => (
                                  <Box
                                    key={service._id || `service-${index}`}
                                    sx={{ mb: 1 }}
                                  >
                                    <div>
                                      {service.service === "Other"
                                        ? service.otherService ||
                                        "Other Service"
                                        : service.service}
                                    </div>
                                    {(service.price > 0 ||
                                      service.quantity > 1) && (
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                        >
                                          {service.quantity} x ₹{service.price}
                                          {service.description &&
                                            ` - ${service.description}`}
                                        </Typography>
                                      )}
                                    {index <
                                      lead.serviceInterested.length - 1 && (
                                        <Divider sx={{ my: 0.5 }} />
                                      )}
                                  </Box>
                                ))
                              ) : (
                                <span
                                  style={{ color: "gray", fontStyle: "italic" }}
                                >
                                  No services specified
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                  alignItems: "flex-start",
                                }}
                              >
                                {/* Multi-Status Chips */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                  {/* Classification Status */}
                                  {(lead.classificationStatus && lead.classificationStatus !== 'none') || (["hot", "warm", "cold", "dead", "closed", "new", "follow-up"].includes(lead.status)) ? (
                                    <Chip
                                      label={getDisplayStatus(lead.classificationStatus || lead.status)}
                                      size="small"
                                      color={getStatusChipColor(lead.classificationStatus || lead.status)}
                                      sx={{ fontWeight: "bold" }}
                                    />
                                  ) : null}

                                  {/* Scheduling Status */}
                                  {lead.schedulingStatus && lead.schedulingStatus !== 'none' && (
                                    <Chip
                                      label={getDisplayStatus(lead.schedulingStatus)}
                                      size="small"
                                      color={getStatusChipColor(lead.schedulingStatus)}
                                      sx={{ fontWeight: "bold" }}
                                    />
                                  )}

                                  {/* Quotation Status */}
                                  {lead.quotationStatus && lead.quotationStatus !== 'none' && (
                                    <Chip
                                      label={getDisplayStatus(lead.quotationStatus)}
                                      size="small"
                                      color={getStatusChipColor(lead.quotationStatus)}
                                      sx={{ fontWeight: "bold" }}
                                    />
                                  )}

                                  {/* Payment Status */}
                                  {lead.paymentStatus &&
                                    lead.paymentStatus !== 'none' &&
                                    lead.paymentStatus !== 'pending' &&
                                    lead.paymentStatus !== 'payment_pending' &&
                                    lead.quotations?.length > 0 && (
                                      <Chip
                                        label={getDisplayStatus(lead.paymentStatus)}
                                        size="small"
                                        sx={{
                                          fontWeight: "bold",
                                          backgroundColor: (lead.paymentStatus === 'fully_paid') ? 'success.main' : 'error.main',
                                          color: 'white',
                                          ml: 0.5,
                                          boxShadow: (lead.paymentStatus === 'fully_paid')
                                            ? `0 0 8px ${alpha(theme.palette.success.main, 0.4)}`
                                            : `0 0 8px ${alpha(theme.palette.error.main, 0.4)}`,
                                          '& .MuiChip-label': { px: 1 }
                                        }}
                                      />
                                    )}

                                  {/* Legacy Status Fallback (if none of the above matched or for mixed statuses) */}
                                  {!lead.classificationStatus && !lead.schedulingStatus && !lead.quotationStatus && (
                                    <Chip
                                      label={getDisplayStatus(lead.status)}
                                      size="small"
                                      color={getStatusChipColor(lead.status)}
                                      sx={{ fontWeight: "bold" }}
                                    />
                                  )}
                                </Box>

                                {/* Call Status with Icon */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  {getCallStatusIcon(lead.callStatus)}
                                  <Typography
                                    variant="body2"
                                    sx={{ fontSize: "0.75rem" }}
                                  >
                                    {getCallStatusText(lead.callStatus)}
                                  </Typography>
                                </Box>

                                {/* Number of Calls */}
                                {lead.noOfTimesCalled > 0 && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        backgroundColor: "primary.main",
                                        color:
                                          mode === "light" ? "#fff" : "#0f172a",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "0.7rem",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {lead.noOfTimesCalled}
                                    </Box>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "0.75rem",
                                        color: "text.secondary",
                                      }}
                                    >
                                      calls
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell sx={{ borderRight: `1px solid ${alpha(primaryColor, 0.1)}` }}>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                {lead.leadCallDate ? (
                                  <>
                                    {/* 🚨 PRIORITY ORDER: Show the most relevant date for each status */}
                                    {(() => {
                                      // Get the appropriate date based on lead status
                                      const displayDate = getDisplayDateForLead(lead);

                                      if (!displayDate) {
                                        return (
                                          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                            {formatDate(lead.leadCallDate)}
                                          </Typography>
                                        );
                                      }

                                      return (
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                          {/* Show date type indicator AS BADGE */}
                                          {getDateTypeLabel(lead) && (
                                            <Chip
                                              label={getDateTypeLabel(lead)}
                                              size="small"
                                              sx={{
                                                fontWeight: "bold",
                                                backgroundColor: alpha(secondaryColor, 0.1),
                                                color: secondaryColor,
                                                border: `1px solid ${alpha(secondaryColor, 0.2)}`,
                                                borderRadius: "4px",
                                                fontSize: "0.65rem",
                                                height: "20px",
                                                width: "fit-content",
                                                textTransform: "uppercase"
                                              }}
                                            />
                                          )}

                                          {/* MAIN DATE TO SHOW AS PLAIN BOLD TEXT */}
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontWeight: "bold",
                                              color: "text.primary",
                                              ml: 0.5
                                            }}
                                          >
                                            {formatDate(displayDate)}
                                          </Typography>
                                        </Box>
                                      );
                                    })()}

                                    {/* Time (if any) */}
                                    {/* {lead.isDateOnly !== true && (
          <Typography
            variant="body2"
            sx={{
              color: "primary.main",
              fontSize: "0.75rem",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <CalendarToday sx={{ fontSize: 14 }} />
            {formatTime(lead.leadCallDate)}
          </Typography>
        )} */}

                                    {/* Meeting Indicator */}
                                    {getDateTypeLabel(lead) === "Meeting on" &&
                                      lead.meeting &&
                                      lead.meeting.dateTime && (
                                        <Box
                                          sx={{
                                            mt: 0.3,
                                            p: 0.2,
                                            backgroundColor: alpha(secondaryColor, 0.1),
                                            borderRadius: 1,
                                            border: `1px solid ${alpha(secondaryColor, 0.2)}`,
                                          }}
                                        >
                                          {lead.meeting.platform && (
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                color: "text.secondary",
                                                display: "block",
                                                ml: 1,
                                              }}
                                            >
                                              ({formatPlatform(lead.meeting.platform)})
                                            </Typography>
                                          )}
                                        </Box>
                                      )}
                                  </>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "text.secondary",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    N/A
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{
                                borderRight: `1px solid ${alpha(
                                  primaryColor,
                                  0.1
                                )}`,
                              }}
                            >
                              <Box sx={{ display: "flex", gap: 0.5 }}>
                                {/* Records Button */}
                                <IconButton
                                  size="small"
                                  onClick={() => navigate(`/lead/${lead._id}`)}
                                  sx={{
                                    color: redcolor,
                                    "&:hover": {
                                      backgroundColor: alpha(redcolor, 0.1),
                                    },
                                    borderRadius: 1,
                                  }}
                                  title="View Records"
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>

                                {/* Update Button */}
                                {canUpdateLead && (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenUpdateDialog(lead)}
                                    sx={{
                                      color: greencolor,
                                      "&:hover": {
                                        backgroundColor: alpha(greencolor, 0.1),
                                      },
                                      borderRadius: 1,
                                    }}
                                    title="Update Lead"
                                  >
                                    <Edit fontSize="small" />
                                  </IconButton>
                                )}

                                {/* 🆕 TEAM COLLABORATION BUTTON - ALWAYS VISIBLE */}
                                <CollaborationTooltip
                                  leadId={lead._id}
                                  hasCollaboration={leadsWithCollaboration.has(
                                    lead._id
                                  )}
                                  participants={
                                    collaborationParticipants[lead._id] || []
                                  }
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleOpenTeamCollaboration(lead)
                                    }
                                    sx={{
                                      color: leadsWithCollaboration.has(
                                        lead._id
                                      )
                                        ? "success.main"
                                        : "grey.500",
                                      "&:hover": {
                                        backgroundColor:
                                          leadsWithCollaboration.has(lead._id)
                                            ? alpha(
                                              theme.palette.success.main,
                                              0.1
                                            )
                                            : alpha(
                                              theme.palette.grey[500],
                                              0.1
                                            ),
                                      },
                                      borderRadius: 1,
                                    }}
                                  >
                                    <GroupsIcon fontSize="small" />
                                  </IconButton>
                                </CollaborationTooltip>
                                {(canUpdateLead) && (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteLead(lead._id)}
                                    sx={{
                                      color: "error.main",
                                      "&:hover": {
                                        backgroundColor: alpha(
                                          theme.palette.error.main,
                                          0.08
                                        ),
                                      },
                                      borderRadius: 1,
                                    }}
                                    title="Delete Lead"
                                  >
                                    <Delete fontSize="small" />
                                  </IconButton>
                                )}
                              </Box>
                            </TableCell>
                            {canAssignLead && (
                              <TableCell>
                                {/* Assign Button */}
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    handleOpenAssignLead();
                                    setSelectedLead(lead);
                                  }}
                                  sx={{
                                    color: "primary.main",
                                    "&:hover": {
                                      backgroundColor: alpha(primaryColor, 0.1),
                                    },
                                    borderRadius: 1,
                                  }}
                                  title="Assign Lead"
                                >
                                  <Assignment fontSize="small" />
                                </IconButton>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>
      </Box >

      {/* Custom Alert */}
      < CustomAlert
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        onClose={handleCloseAlert}
      />

      {/* Filter Popover */}
      {/* Filter Popover */}
      {/* Filter Popover - Updated with fixed height and scroll */}
      <Popover
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleCloseFilterPopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            p: 2,
            minWidth: 300,
            maxWidth: 350,
            borderRadius: 2,
            border: `2px solid ${alpha(primaryColor, 0.1)}`,
            bgcolor: "background.paper",
            // 🆕 FIXED HEIGHT FOR ENTIRE MODAL
            maxHeight: "500px", // Fixed overall height
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ flexShrink: 0 }}>
          Filters
        </Typography>

        {/* Scrollable content container */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            flex: 1,
            overflowY: "auto", // Scroll entire content if needed
            pr: 1, // Add padding for scrollbar
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: alpha(primaryColor, 0.05),
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: alpha(primaryColor, 0.2),
              borderRadius: "3px",
              "&:hover": {
                background: alpha(primaryColor, 0.3),
              },
            },
          }}
        >
          {/* Status Filter - FIXED HEIGHT WITH INTERNAL SCROLL */}
          <FormControl fullWidth size="small" sx={{ flexShrink: 0, mt: 1 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={tempFilters.status}
              label="Status"
              onChange={(e) =>
                setTempFilters({ ...tempFilters, status: e.target.value })
              }
              // 🆕 MAKE SELECT DROPDOWN SCROLLABLE WITH FIXED HEIGHT
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300, // Fixed height for dropdown
                    "& .MuiMenuItem-root": {
                      fontSize: "0.875rem", // Smaller font
                      py: 0.75, // Reduced padding
                    },
                    "& .MuiTypography-caption": {
                      pl: 1.5,
                      pt: 1,
                      pb: 0.5,
                      fontSize: "0.7rem",
                      fontWeight: 600,
                      color: theme.palette.text.secondary,
                      backgroundColor: alpha(primaryColor, 0.03),
                    }
                  }
                }
              }}
            >
              <MenuItem value="all">All Statuses</MenuItem>


              <MenuItem value="hot">Hot Leads</MenuItem>
              <MenuItem value="warm">Warm Leads</MenuItem>
              {/* <MenuItem value="follow_up">Follow Up</MenuItem> */}

              <MenuItem value="meeting">Meeting Scheduled</MenuItem>
              <MenuItem value="rescheduled">Rescheduled</MenuItem>


              <MenuItem value="quotation">Quotation Shared</MenuItem>
              <MenuItem value="quotation_approved">Quotation Approved</MenuItem>
              <MenuItem value="quotation_revised">Quotation Revised</MenuItem>
              <MenuItem value="quotation_rejected">Quotation Rejected</MenuItem>
              <MenuItem value="negotiation">Negotiation</MenuItem>


              {/* <MenuItem value="token_paid">Token Paid</MenuItem> */}
              {/* <MenuItem value="partially_paid">Partially Paid</MenuItem> */}
              <MenuItem value="fully_paid">Fully Paid</MenuItem>
              <MenuItem value="payment_overdue">Payment Overdue</MenuItem>
              <MenuItem value="payment_pending">Payment Pending</MenuItem>


              <MenuItem value="closed">Deal Closed</MenuItem>
              <MenuItem value="dead">Dead Leads</MenuItem>
            </Select>
          </FormControl>

          {/* Company Filter for Super Admin */}
          {userRole === "superAdmin" && (
            <FormControl fullWidth size="small" sx={{ flexShrink: 0 }}>
              <InputLabel>Company</InputLabel>
              <Select
                value={tempFilters.company}
                label="Company"
                onChange={(e) =>
                  setTempFilters({ ...tempFilters, company: e.target.value })
                }
                // 🆕 FIXED HEIGHT FOR COMPANY DROPDOWN TOO
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                    }
                  }
                }}
              >
                <MenuItem value="all">All Companies</MenuItem>
                {companies.map((company) => (
                  <MenuItem key={company._id} value={company._id}>
                    {company.companyName || company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Optional additional filters section */}
          {/* <Divider sx={{ my: 1 }} />
    <Box sx={{ flexShrink: 0 }}>
      <Typography variant="subtitle2" gutterBottom>
        Additional Filters
      </Typography>
      <TextField
        fullWidth
        size="small"
        label="Client Name"
        placeholder="Search by name"
      />
    </Box> */}
        </Box>

        {/* Fixed buttons at bottom - ALWAYS VISIBLE */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
            mt: 2,
            pt: 2,
            borderTop: `1px solid ${alpha(primaryColor, 0.1)}`,
            flexShrink: 0,
          }}
        >
          <Button onClick={handleResetFilters} color="inherit" size="small">
            Reset
          </Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            size="small"
            sx={{
              bgcolor: "primary.main",
              "&:hover": {
                bgcolor: alpha(primaryColor, 0.9),
              },
            }}
          >
            Apply
          </Button>
        </Box>
      </Popover>

      {/* Add Lead Popup */}
      <Dialog
        open={openAddLeadPop}
        onClose={handleCloseAddLead}
        maxWidth="md"
        PaperProps={{
          sx: {
            backgroundColor: "white",
          },
        }}
      >
        <AddLead
          userData={userData}
          onClose={handleCloseAddLead}
          onSuccess={fetchLeads}
        />
      </Dialog>
      {
        canUpdateLead && (
          <Dialog
            open={openUpdateDialog}
            onClose={handleCloseUpdateDialog}
            fullWidth
            maxWidth="md"
            PaperProps={{
              sx: {
                maxHeight: "85vh",
                borderRadius: "8px",
              },
            }}
          >
            <DialogTitle
              sx={{
                fontWeight: "bold",
                pb: 2,
                fontSize: "1.3rem",
                borderBottom: "1px solid #e0e0e0",
                background: "white",
                color: "#333",
                textAlign: "center",
              }}
            >
              Update Lead Status
            </DialogTitle>

            <DialogContent
              sx={{
                py: 3,
                background: "white",
                overflowY: "auto",
                pt: 4,
              }}
            >
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}
              >

                {/* 2. CALL STATUS - Always show */}
                <FormControl fullWidth>
                  <InputLabel>Call Status *</InputLabel>
                  <Select
                    label="Call Status *"
                    name="callStatus"
                    value={formData.callStatus}
                    onChange={handleCallStatusChange}
                    sx={{
                      background: "#f8f9fa",
                      "& .MuiSelect-select": { padding: "12px 14px" },
                    }}
                  >
                    <MenuItem value="call_not_received">
                      Call Not Received
                    </MenuItem>
                    <MenuItem value="received">Call Received</MenuItem>
                    <MenuItem value="switch_off">Switch Off</MenuItem>
                    <MenuItem value="wrong_number">Wrong Number</MenuItem>
                  </Select>
                </FormControl>

                {/* 3. CLASSIFICATION & QUOTATION STATUS - Only for received calls */}
                {formData.callStatus === "received" && (
                  <>
                    <FormControl fullWidth>
                      <InputLabel>Lead Classification</InputLabel>
                      <Select
                        label="Lead Classification"
                        name="leadStatus"
                        value={classificationStatuses.includes(formData.leadStatus) ? formData.leadStatus : ""}
                        onChange={handleChange}
                        sx={{ background: "#f8f9fa" }}
                      >
                        <MenuItem value="">No direct change</MenuItem>
                        <MenuItem value="hot">Hot Lead</MenuItem>
                        <MenuItem value="warm">Warm Lead</MenuItem>
                        <MenuItem value="dead">Dead Lead</MenuItem>
                        <MenuItem value="send_quotation">
                          {selectedLead?.quotations?.length > 0 ? "Revise Quotation" : "Make Quotation"}
                        </MenuItem>
                        <MenuItem value="closed">Deal Closed</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Integrated Quotation Status Update (Original logic) */}
                    {(selectedLead?.quotations?.length > 0 || formData.leadStatus === "send_quotation" || selectedLead?.status?.startsWith("quotation_")) && (
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Update Quotation Status</InputLabel>
                        <Select
                          label="Update Quotation Status"
                          value={formData.quotationStatus || ""}
                          onChange={(e) => handleQuotationStatusChange(e.target.value)}
                          sx={{ background: "#f8f9fa" }}
                        >
                          <MenuItem value="">Keep Current Status</MenuItem>
                          {getQuotationStatusOptions(
                            formData.quotationStatus || selectedLead?.quotationStatus || selectedLead?.status,
                            selectedLead?.quotations?.[selectedLead.quotations.length - 1]
                          ).map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}

                {/* 4. SCHEDULING ACTIONS - Show for all call statuses except wrong number */}
                {formData.callStatus &&
                  formData.callStatus !== "wrong_number" && (
                    <FormControl fullWidth>
                      <InputLabel>Scheduling Actions</InputLabel>
                      <Select
                        label="Scheduling Actions"
                        name="schedulingAction"
                        value={formData.schedulingAction || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFormData((prev) => ({
                            ...prev,
                            schedulingAction: value,
                          }));
                        }}
                        sx={{ background: "#f8f9fa" }}
                      >
                        <MenuItem value="">No scheduling action</MenuItem>
                        <MenuItem value="rescheduled">
                          Reschedule Call
                        </MenuItem>
                        {formData.callStatus === "received" && (
                          <MenuItem value="meeting_scheduled">
                            Schedule Meeting
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  )}

                {/* 5. SCHEDULING DETAILS SECTION */}
                {(formData.schedulingAction === "meeting_scheduled" ||
                  formData.schedulingAction === "rescheduled") && (
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        bgcolor: "#fafafa",
                      }}
                    >
                      <Typography variant="h6" sx={{ mb: 2, color: "#333" }}>
                        {formData.schedulingAction === "meeting_scheduled"
                          ? "Schedule Meeting"
                          : "Reschedule Call"}
                      </Typography>

                      {formData.schedulingAction === "meeting_scheduled" && (
                        <>
                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Meeting Platform</InputLabel>
                            <Select
                              label="Meeting Platform"
                              name="meetingPlatform"
                              value={formData.meetingPlatform}
                              onChange={handleChange}
                              sx={{ background: "white" }}
                            >
                              <MenuItem value="offline">Offline Meeting</MenuItem>
                              <MenuItem value="zoom">Zoom</MenuItem>
                              <MenuItem value="google_meet">Google Meet</MenuItem>
                              <MenuItem value="microsoft_teams">Microsoft Teams</MenuItem>
                              <MenuItem value="phone_call">Phone Call</MenuItem>
                            </Select>
                          </FormControl>

                          {formData.meetingPlatform === "offline" ? (
                            <TextField
                              fullWidth
                              label="Meeting Location"
                              name="location"
                              value={formData.location}
                              onChange={handleChange}
                              sx={{ mb: 2, background: "white" }}
                              placeholder="Enter meeting venue address"
                            />
                          ) : (
                            <TextField
                              fullWidth
                              label="Meeting Link"
                              name="meetingLink"
                              value={formData.meetingLink}
                              onChange={handleChange}
                              sx={{ mb: 2, background: "white" }}
                              placeholder="Paste meeting link here"
                            />
                          )}
                        </>
                      )}

                      {/* DATE FIELD - Always required */}
                      <TextField
                        fullWidth
                        label="Date"
                        type="date"
                        name="dateTime"
                        value={formData.dateTime ? formData.dateTime.split('T')[0] : ""}
                        onChange={(e) => {
                          const dateOnly = e.target.value;
                          const timePart = formData.dateTime && formData.dateTime.includes('T')
                            ? formData.dateTime.split('T')[1]
                            : "00:00";

                          setFormData(prev => ({
                            ...prev,
                            dateTime: `${dateOnly}T${timePart}`
                          }));
                        }}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2, background: "white" }}
                        required
                      />

                      {/* TIME OPTIONAL CHECKBOX */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.includeTime || false}
                            onChange={(e) => {
                              const includeTime = e.target.checked;
                              setFormData((prev) => ({
                                ...prev,
                                includeTime: includeTime,
                                dateTime: includeTime
                                  ? (prev.dateTime && prev.dateTime.includes('T') ? prev.dateTime : `${prev.dateTime || ""}T09:00`)
                                  : (prev.dateTime ? prev.dateTime.split('T')[0] : "")
                              }));
                            }}
                            size="small"
                          />
                        }
                        label="Include specific time"
                        sx={{ mb: 1 }}
                      />

                      {/* TIME FIELD */}
                      {formData.includeTime && (
                        <TextField
                          fullWidth
                          label="Time"
                          type="time"
                          name="time"
                          value={
                            formData.dateTime && formData.dateTime.includes('T')
                              ? formData.dateTime.split('T')[1].substring(0, 5)
                              : "09:00"
                          }
                          onChange={(e) => {
                            const time = e.target.value;
                            const datePart = formData.dateTime ? formData.dateTime.split('T')[0] : "";
                            if (datePart) {
                              setFormData(prev => ({
                                ...prev,
                                dateTime: `${datePart}T${time}`
                              }));
                            }
                          }}
                          InputLabelProps={{ shrink: true }}
                          sx={{ mb: 2, background: "white" }}
                        />
                      )}

                      {formData.schedulingAction === "meeting_scheduled" && (
                        <TextField
                          fullWidth
                          label="Meeting Remarks"
                          name="meetingRemarks"
                          value={formData.meetingRemarks}
                          onChange={handleChange}
                          multiline
                          rows={2}
                          sx={{ background: "white" }}
                          placeholder="Any specific agenda or notes for the meeting..."
                        />
                      )}
                    </Box>
                  )}


                {/* 6. CREATE/REVISE QUOTATION SECTION */}
                {(formData.leadStatus === "send_quotation" || formData.quotationStatus === "send_quotation") && (
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", mb: 2, color: "#333", textAlign: "center" }}
                    >
                      {selectedLead?.quotations?.length > 0 ? "Revise Quotation" : "Create Quotation"}
                    </Typography>

                    {/* Service Selection and Configuration */}
                    <Box sx={{ mb: 3, p: 2, background: "#f8f9fa", borderRadius: "6px" }}>
                      <FormControl fullWidth>
                        <InputLabel>Add Service</InputLabel>
                        <Select
                          value=""
                          label="Add Service"
                          onChange={(e) => addServiceToQuotation(e.target.value)}
                          sx={{ background: "white" }}
                        >
                          <MenuItem value="">Choose a service...</MenuItem>
                          {ServiceOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>

                    {/* Service Cards */}
                    {formData.quotationData.services.map((service) => (
                      <Box key={service._id} sx={{ mb: 2, p: 2, background: "#f8f9fa", borderRadius: "6px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>{service.serviceName}</Typography>
                          <Box>
                            <IconButton onClick={() => handlePreviewPDF(service)} color="primary" size="small" sx={{ mr: 1 }}>
                              <Visibility fontSize="small" />
                            </IconButton>
                            <IconButton onClick={() => removeServiceFromQuotation(service._id)} color="error" size="small">
                              <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>
                        <Grid container spacing={2}>
                          {service.fields.map((field) => (
                            <Grid key={field.name} item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label={field.label}
                                type={field.type}
                                value={field.value || ""}
                                onChange={(e) => updateServiceField(service._id, field.name, e.target.value)}
                                InputProps={{
                                  startAdornment: field.priceField ? <InputAdornment position="start">₹</InputAdornment> : null
                                }}
                                sx={{ background: "white" }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        <Typography sx={{ mt: 2, fontWeight: "bold", color: "#2e7d32", textAlign: "right" }}>
                          Total: ₹{service.calculatedTotal?.toLocaleString()}
                        </Typography>
                      </Box>
                    ))}

                    {/* Quotation Summary */}
                    {formData.quotationData.services.length > 0 && (
                      <Box sx={{ p: 2, background: "#ffffff", borderRadius: "6px", mt: 2 }}>
                        <Grid container spacing={2}>
                          {/* <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            type="number"
                            label="Discount (₹)"
                            value={formData.quotationData.discount}
                            onChange={(e) => setFormData(prev => ({
                              ...prev,
                              quotationData: { ...prev.quotationData, discount: e.target.value }
                            }))}
                            sx={{ background: "white" }}
                          />
                        </Grid> */}
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              type="date"
                              label="Valid Until"
                              value={formData.quotationData.validUntil}
                              onChange={(e) => setFormData(prev => ({
                                ...prev,
                                quotationData: { ...prev.quotationData, validUntil: e.target.value }
                              }))}
                              InputLabelProps={{ shrink: true }}
                              sx={{ background: "white" }}
                            />
                          </Grid>
                        </Grid>
                        <Typography variant="h5" sx={{ mt: 2, fontWeight: "bold", color: "#19d266", textAlign: "right" }}>
                          Final Amount: ₹{calculateFinalAmount().toLocaleString()}
                        </Typography>

                        {formData.quotationData.services.length > 1 && (
                          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button
                              variant="outlined"
                              startIcon={<Visibility />}
                              onClick={handlePreviewAllPDF}
                              size="small"
                            >
                              Preview Full Quotation
                            </Button>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                )}

                {/* 7. REMARKS - Always show */}
                <TextField
                  fullWidth
                  label="Overall Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  sx={{ background: "#f8f9fa", mt: 1 }}
                  placeholder="Key takeaways from this interaction..."
                />
              </Box>
            </DialogContent>

            {/* ACTION BUTTONS */}
            {/* ACTION BUTTONS - UPDATED VALIDATION */}
            <DialogActions
              sx={{
                px: 3,
                py: 2,
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                justifyContent: "space-between",
                background: "white",
              }}
            >
              <Button
                onClick={handleCloseUpdateDialog}
                variant="outlined"
                size="large"
                sx={{
                  border: "1px solid #f44336",
                  color: "#f44336",
                  fontWeight: "600",
                  px: 3,
                  "&:hover": {
                    background: "#f44336",
                    color: "white",
                    border: "1px solid #f44336",
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                size="large"
                onClick={
                  (formData.quotationStatus === "send_quotation" || formData.leadStatus === "send_quotation") && selectedLead?.quotations?.length > 0
                    ? handleCreateRevisedQuotation
                    : handleUpdateLeadStatus
                }
                disabled={
                  loading ||
                  // 🚨 REMOVED STRICT VALIDATION - Only basic requirements
                  (!formData.callStatus && !formData.quotationStatus) ||
                  // Only validate services if actually sending quotation
                  ((formData.leadStatus === "send_quotation" ||
                    formData.quotationStatus === "send_quotation") &&
                    formData.quotationData.services.length === 0)
                }
                sx={{
                  background: "#4caf50",
                  "&:hover": { background: "#45a049" },
                  color: "white",
                  fontWeight: "bold",
                  px: 4,
                }}
              >
                {loading
                  ? (formData.quotationStatus === "send_quotation" || formData.leadStatus === "send_quotation") && selectedLead?.quotations?.length > 0
                    ? "Creating Revision..."
                    : "Updating..."
                  : "Update Status"}
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
      {/* View Remarks Dialog */}
      {
        viewRemarksOpen && selectedLead && (
          <Dialog
            open={viewRemarksOpen}
            onClose={handleCloseViewRemarks}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                backgroundColor: "white",
              },
            }}
          >
            <DialogTitle>View Remarks</DialogTitle>
            <DialogContent>
              <LeadRemarks leadId={selectedLead._id} />
            </DialogContent>
          </Dialog>
        )
      }

      {
        teamCollaborationOpen && selectedLeadForCollaboration && (
          <TeamCollaborationModal
            open={teamCollaborationOpen}
            onClose={handleCloseTeamCollaboration}
            lead={selectedLeadForCollaboration}
            userData={userData}
            onSuccess={handleTeamCollaborationSuccess}
          />
        )
      }

      {/* Payment Dialog */}

      <Dialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            💰 Record Payment
          </Typography>
          {selectedQuotation && (
            <Typography variant="body2" color="text.secondary">
              Quotation: {selectedQuotation.quotationNumber} | Total: ₹
              {selectedQuotation.finalAmount?.toLocaleString()} | Paid: ₹
              {selectedQuotation.paidAmount?.toLocaleString()} | Balance: ₹
              {selectedQuotation.balanceAmount?.toLocaleString()}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <TextField
              label="Amount *"
              type="number"
              value={paymentForm.amount}
              onChange={(e) =>
                setPaymentForm({ ...paymentForm, amount: e.target.value })
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
              helperText={`Maximum: ₹${selectedQuotation?.balanceAmount?.toLocaleString() || 0
                }`}
            />

            <FormControl fullWidth>
              <InputLabel>Payment Type *</InputLabel>
              <Select
                value={paymentForm.paymentType}
                label="Payment Type *"
                onChange={(e) =>
                  setPaymentForm({
                    ...paymentForm,
                    paymentType: e.target.value,
                  })
                }
              >
                <MenuItem value="advance">Advance Payment</MenuItem>
                <MenuItem value="token">Token Amount</MenuItem>
                <MenuItem value="installment">Installment</MenuItem>
                <MenuItem value="full">Full Payment</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Payment Method *</InputLabel>
              <Select
                value={paymentForm.paymentMethod}
                label="Payment Method *"
                onChange={(e) =>
                  setPaymentForm({
                    ...paymentForm,
                    paymentMethod: e.target.value,
                  })
                }
              >
                <MenuItem value="cash">Cash</MenuItem>
                <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                <MenuItem value="cheque">Cheque</MenuItem>
                <MenuItem value="online">Online Payment</MenuItem>
                <MenuItem value="card">Card</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Transaction ID/Reference"
              value={paymentForm.transactionId}
              onChange={(e) =>
                setPaymentForm({
                  ...paymentForm,
                  transactionId: e.target.value,
                })
              }
              placeholder="e.g., UPI Ref, Cheque No, etc."
            />

            <TextField
              label="Remarks"
              multiline
              rows={2}
              value={paymentForm.remarks}
              onChange={(e) =>
                setPaymentForm({ ...paymentForm, remarks: e.target.value })
              }
              placeholder="Additional payment details..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={handleRecordPayment}
            variant="contained"
            disabled={
              !paymentForm.amount ||
              !paymentForm.paymentType ||
              !paymentForm.paymentMethod
            }
            startIcon={<Payment />}
          >
            Record Payment
          </Button>
        </DialogActions>
      </Dialog>

      {/* Assign Lead Dialog */}
      {
        assignLeadOpen && selectedLead && canAssignLead && (
          <Dialog
            open={assignLeadOpen}
            onClose={handleCloseAssignLead}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                backgroundColor:
                  mode === "dark" ? theme.palette.background.paper : "white",
                borderRadius: 2,
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              },
            }}
          >
            <AssignTeamMemberLead
              userData={userData}
              leadId={selectedLead._id}
              onClose={handleCloseAssignLead}
              onSuccess={fetchLeads}
            />
          </Dialog>
        )
      }
    </>
  );
};
export default Leads;
